import { billingAr } from "./billing.ar";
import { hrAr } from "./hr.ar";
import { dashboardAr } from "./dashboard.ar";
import { paymentsAr } from "./payments.ar";
import { reportsAr } from "./reports.ar";
import type { MessageId } from "./fr";

/** Arabic catalog. Same keys and {placeholders} as fr.ts (checked by catalogs.t.ts). */
// Terms: feature = ميزة, feature enablement = تفعيل الميزة, role = دور, case (dossier) = ملف, pro = محترف, client = عميل, job request (demande) = طلب, lead (opportunité) = فرصة, reason (motif) = السبب, reveal (afficher) = إظهار, staff member = عضو الفريق, sign out = تسجيل الخروج
export const ar: Record<MessageId, string> = {
  ...reportsAr,
  ...paymentsAr,
  ...dashboardAr,
  ...billingAr,
  ...hrAr,
  // ── Brand and shell ──
  "brand.name": "Walliyo",
  "brand.initial": "و",
  "brand.console": "لوحة التحكم",
  "nav.aria": "لوحة التحكم",
  "nav.new": "جديد",
  "nav.group.configuration": "الإعدادات العامة",
  "overview.eachDepartment": "كل قسم في سطر",
  "overview.dept.marketplace": "عمليات السوق",
  "overview.dept.growth": "المبيعات والنمو",
  "overview.dept.support": "خدمة العملاء",
  "overview.dept.trust": "الثقة والسلامة",
  "overview.dept.finance": "المالية",
  "overview.dept.people": "الموارد البشرية",
  "overview.dept.administration": "الإدارة",
  "overview.dept.product": "الهندسة",
  "overview.clickThrough": "انقر للانتقال",
  "overview.numberToWatch": "الرقم الجدير بالمتابعة",
  "overview.whereWalliyoWorks": "أين تعمل واليو",
  "overview.noCitiesYet": "لا طلبات هذا الشهر.",
  "overview.points": "{points} نقاط",
  "overview.title.people.walliyoMonth": "واليو، {month}",
  "overview.people.tab.waiting": "ما ينتظرك",
  "overview.people.tab.company": "الشركة",
  "overview.people.tab.weeks": "الأسابيع القادمة",
  "overview.people.askForTimeOff": "اطلب إجازة",
  "overview.people.joinedThisMonth": "{count} انضموا هذا الشهر",
  "overview.people.joinedThisMonth.one": "واحد انضم هذا الشهر",
  "overview.people.candidates": "{count} مرشحين",
  "overview.people.candidates.one": "مرشح واحد",
  "overview.people.medianStay": "سنوات، مدة البقاء الوسيطة",
  "overview.people.whereEverybodyIs": "أين كل واحد",
  "overview.people.oneLinePerTeam": "سطر لكل فريق",
  "overview.people.noTeamsYet": "لا فرق بعد.",
  "overview.people.noLead": "بلا مسؤول",
  "overview.people.nobodyCovering": "لا أحد يغطّي",
  "overview.people.thinWeek": "{team} يفقد {away} من {size} في أسبوع {week}.",
  "overview.people.whoIsWhere": "من في أي مكان",
  "overview.people.fourWeeks": "أربعة أسابيع، وما يقع في كل منها",
  "overview.people.allTimeOff": "كل الإجازات",
  "overview.people.quietWeeks": "لا شيء يقع في الأسابيع الأربعة القادمة.",
  "overview.people.mark.payrollCloses": "الرواتب تُغلق {on}",
  "overview.people.mark.reviewsClose": "التقييمات تُغلق {on}",
  "overview.people.span.leave": "{days} أيام إجازة",
  "overview.people.span.leave.one": "يوم إجازة واحد",
  "overview.people.span.leavePending": "{days} أيام · غير محسومة",
  "overview.people.span.leavePending.one": "يوم واحد · غير محسوم",
  "overview.people.span.starts": "يبدأ",
  "overview.people.task.candidates": "{count} مرشحين ينتظرونك",
  "overview.people.detail.candidates": "على {second} وظائف مفتوحة",
  "marketplace.seeAll": "اعرض الـ{count} كلها",
  "marketplace.findAPro": "اعثر على محترف",
  "marketplace.theMarket": "السوق، هذا الأسبوع",
  "overview.title.marketplace.theMarket": "السوق، هذا الأسبوع",
  "overview.lede.marketplace.nobodyAnswered": "{first} أشخاص طلبوا شيئًا ولم يردّ أحد.",
  "overview.lede.marketplace.demandNoSupply": "{first} مهن مطلوبة حيث لا يملك أي محترف المهارة.",
  "overview.lede.marketplace.quiet": "لم يُنشر شيء هذا الأسبوع.",
  "overview.lede.marketplace.allAnswered": "كل عمل نُشر هذا الأسبوع حصل على عرض.",
  "overview.people.link.employees": "الموظفون",
  "overview.people.link.recruiting": "التوظيف",
  "overview.people.link.learning": "التدريب",
  "overview.people.link.teams": "الفرق",
  "overview.administration.askedNotAnswered": "طُلب، ولم يُجَب",
  "overview.administration.oldestFirst": "الأقدم أولًا",
  "overview.administration.nobodyWaiting": "لا أحد ينتظر ردًا.",
  "overview.administration.row.wantsUntil": "{subject} يريد أن {asked}",
  "overview.administration.row.wantsForever": "{subject} يريد أن {asked}، بلا تاريخ انتهاء",
  "overview.administration.until": "حتى {on}",
  "overview.administration.noEndAsked": "لم يُطلب تاريخ انتهاء",
  "overview.administration.hoursWaiting": "{hours} ساعات انتظار",
  "overview.administration.hoursWaiting.one": "ساعة واحدة من الانتظار",
  "overview.administration.pastTheDeadline": "تجاوز الموعد",
  "overview.administration.nobodyTookItBack": "لم يستردّها أحد",
  "overview.administration.noEndDate": "{count} صلاحيات بلا تاريخ انتهاء.",
  "overview.administration.noEndDate.one": "صلاحية واحدة بلا تاريخ انتهاء.",
  "overview.administration.belongToLeavers": "{leavers} منها تخص من تركوا العمل.",
  "overview.administration.belongToLeavers.one": "واحدة منها تخص من ترك العمل.",
  "overview.administration.reviewThem": "راجِعها",
  "overview.administration.criticalCapabilities": "القدرات الحرجة",
  "overview.administration.ifAnyReachesOne": "إذا نزلت إحداها إلى شخص واحد، فلن يغطّيها أحد في غيابه.",
  "overview.figure.holdCritical": "يملكون شيئًا حرجًا",
  "overview.lede.administration.waitingAndGrants": "{first} أشخاص ينتظرون ردًا، و{second} صلاحيات بلا تاريخ انتهاء.",
  "overview.lede.administration.waiting": "{first} أشخاص ينتظرون ردًا.",
  "overview.lede.administration.grants": "{first} صلاحيات بلا تاريخ انتهاء ولم يستردّها أحد.",
  "overview.lede.administration.nothingWaiting": "لا أحد ينتظر ردًا.",
  "overview.growth.step.signedUp": "مسجَّلون",
  "overview.growth.step.verified": "موثَّقون",
  "overview.growth.step.addedSkill": "أضافوا مهنة",
  "overview.growth.step.quotedOnce": "قدّموا عرضًا مرة",
  "overview.growth.step.wonAJob": "فازوا بعمل",
  "overview.growth.lost.signedUp": "لم يسجّلوا قط",
  "overview.growth.lost.verified": "انسحبوا",
  "overview.growth.lost.addedSkill": "لم يفعلوها قط",
  "overview.growth.lost.quotedOnce": "لم يقدّموا عرضًا قط",
  "overview.growth.lost.wonAJob": "لم يفوزوا قط",
  "overview.growth.stuck": "متعطّلون، ويستحقون مكالمة",
  "overview.growth.stuckWho": "موثَّقون، في مهنة مطلوبة، ولم يقدّموا عرضًا",
  "overview.growth.nobodyStuck": "لا أحد متعطّل.",
  "overview.growth.row.workGoingUnanswered": "{subject}",
  "overview.growth.why.workGoingUnanswered": "تم توثيقه قبل {days} أيام · عمل في مهنته يبقى بلا رد",
  "overview.growth.row.neverQuoted": "{subject}",
  "overview.growth.why.neverQuoted": "تم توثيقه قبل {days} أيام · لم يقدّم عرضًا قط",
  "overview.growth.promoCost": "منح {given} خصومات مقابل {earned} عمولات من المحترفين الذين استخدموه.",
  "overview.growth.promoUsed": "{used} محترفين استخدموه",
  "overview.growth.beforeYouCampaign": "قبل أن تبدأ حملة",
  "overview.growth.notificationsAreFree":
    "الإشعارات داخل التطبيق تصل إلى هؤلاء المحترفين بلا مقابل. الرسائل القصيرة تُحسب بالرسالة، والبيانات هنا تُدفع بالساعة.",
  "overview.action.call": "اتّصل",
  "overview.lede.growth.neverQuoted": "{first} محترفين سجّلوا ولم يقدّموا أي عرض. هذا هو العمل كله.",
  "overview.lede.growth.nobodySignedUp": "لم يسجّل أحد هذا الشهر.",
  "overview.lede.growth.allWorking": "كل محترف سجّل قدّم عرضًا على شيء.",
  "overview.support.dueInMinutes.one": "الموعد بعد دقيقة واحدة",
  "overview.support.dueInHours.one": "الموعد بعد ساعة واحدة",
  "overview.support.overdue.one": "تجاوزت موعدها بدقيقة واحدة",
  "overview.support.nobodyOwnsWhy.one": "حالة بلا مسؤول هي حالة لا يردّ عليها أحد. أقدمها منتظرة منذ يوم واحد.",
  "overview.people.days.one": "يوم واحد",
  "overview.people.payrollOpen.one": "{month} مفتوح. يُغلق غدًا.",
  "overview.people.detail.leave.one": "طُلبت قبل يوم واحد · أنت المسؤول عنه",
  "overview.finance.waiting.one": "يوم واحد من الانتظار",
  "overview.trust.row.appealWaiting.one": "استئناف منتظر يومًا واحدًا",
  "overview.trust.legalHoldsWhy.one": "حساب واحد محجوز. لا شيء عنه يمكن حذفه، ولا حتى بطلب بيانات.",
  "overview.product.unconfirmed.one": "استدعاء واحد غير مؤكَّد، قبل {minutes} دقيقة.",
  "overview.product.whatIsBroken": "ما هو معطَّل",
  "overview.product.worstFirst": "الأسوأ أولًا",
  "overview.product.nothingBroken": "لا شيء معطَّل.",
  "overview.product.unconfirmed": "{count} استدعاءات غير مؤكَّدة، أقدمها قبل {minutes} دقيقة.",
  "overview.product.unconfirmedWhy": "كل واحد منها محترف دفع ولم يُسجَّل أنه دفع.",
  "overview.product.replayThem": "أعِد تشغيلها",
  "overview.product.rolledOut": "مُطلَق للعملاء",
  "overview.product.tally.everybody": "الجميع",
  "overview.product.tally.someAccounts": "بعض الحسابات",
  "overview.product.tally.off": "مُعطَّل",
  "overview.figure.rolloutsInFlight": "إطلاقات جارية",
  "overview.product.row.incidentOpen": "{subject}",
  "overview.product.why.incidentOpen": "مفتوح منذ {amount} · العملاء يرون الشريط",
  "overview.product.row.ruleScheduled": "القاعدة تسري {at}",
  "overview.product.why.ruleScheduled": "{subject} {amount} · لم يوافق أحد",
  "overview.product.row.experimentRunning": "{subject} عند {days}٪ من العملاء",
  "overview.product.why.experimentRunning": "جارٍ منذ {on} · جاهز للحسم",
  "overview.figure.incidentsOpen": "الحوادث المفتوحة",
  "overview.lede.product.incidentAndCallbacks": "{first} حادث مفتوح، و{second} استدعاءات دفع فشلت.",
  "overview.lede.product.incident": "{first} حادث مفتوح.",
  "overview.lede.product.callbacks": "{first} استدعاءات دفع فشلت ولم يُعِد أحد تشغيلها.",
  "overview.lede.product.rulesScheduled": "{first} قواعد تسري دون حضور أحد.",
  "overview.lede.product.nothingBroken": "لا شيء معطَّل.",
  "overview.finance.aboveLimit": "فوق حدّ شخص ما",
  "overview.finance.theyAskedYouDecide": "هم طلبوا، وأنت تقرّر",
  "overview.finance.nothingWaitingHere": "لا شيء ينتظر موافقة.",
  "overview.finance.theirLimit": "الحدّ {ceiling}",
  "overview.finance.noLimit": "لا يملك أي حدّ",
  "overview.finance.waiting": "{days} أيام انتظار",
  "overview.finance.today": "اليوم",
  "overview.finance.subscriptions": "الاشتراكات",
  "overview.finance.tally.endingSoon": "التجديد خلال ٧ أيام",
  "overview.finance.tally.suspended": "فشل الدفع",
  "overview.finance.tally.ended": "منتهية، غير مجدَّدة",
  "overview.finance.promosRunning": "العروض الجارية",
  "overview.finance.promoEnds": "{name} ينتهي في {on}.",
  "overview.finance.promoNoEnd": "{name} بلا تاريخ انتهاء.",
  "overview.finance.promoCost": "منح {given} خصومات مقابل {earned} عمولات.",
  "overview.figure.feesCollected": "العمولات المحصَّلة",
  "overview.figure.jobsBilled": "الأعمال المفوترة",
  "overview.figure.renewalsFailed": "التجديدات الفاشلة",
  "overview.lede.finance.waitingOnApproval": "{first} تصحيحات تنتظر من يوافق عليها.",
  "overview.lede.finance.renewalsFailed": "{first} تجديدات فشلت ولم يتابعها أحد.",
  "overview.lede.finance.renewingSoon": "{first} اشتراكات تتجدّد هذا الأسبوع.",
  "overview.lede.finance.nothingWaiting": "لا شيء ينتظر موافقة.",
  "overview.trust.needsDecision": "يحتاج قرارًا اليوم",
  "overview.trust.mostSeriousFirst": "الأخطر أولًا",
  "overview.trust.nothingUrgentHere": "لا شيء يحتاج قرارًا اليوم.",
  "overview.trust.verificationQueue": "قائمة التحقق",
  "overview.trust.whyVerify": "المحترف الذي ينتظر التحقق لا يمكن العثور عليه ولا تعيينه.",
  "overview.trust.tally.underADay": "منتظر أقل من ٢٤ ساعة",
  "overview.trust.tally.overADay": "أكثر من ٢٤ ساعة",
  "overview.trust.legalHolds": "الحجوزات القانونية",
  "overview.trust.legalHoldsWhy": "{count} حسابات محجوزة. لا شيء عنها يمكن حذفه، ولا حتى بطلب بيانات.",
  "overview.trust.row.criticalUnreferred": "{subject}",
  "overview.trust.why.criticalUnreferred": "خطير · لم يُحوَّل إلى الشرطة",
  "overview.trust.row.restrictionExpiring": "القيد يُرفع من تلقاء نفسه في {on}",
  "overview.trust.why.restrictionExpiring": "{subject} · ارفعه، أو سيُرفع وحده",
  "overview.trust.row.appealWaiting": "استئناف منتظر {days} أيام",
  "overview.trust.why.appealWaiting": "حساب مقيَّد طلب إعادة النظر",
  "overview.figure.underLegalHold": "تحت حجز قانوني",
  "overview.lede.trust.criticalUnreferred": "{first} تقارير خطيرة ولم يُحوَّل أي منها بعد.",
  "overview.lede.trust.waitingOverADay": "{first} محترفين ينتظرون التحقق أكثر من يوم.",
  "overview.lede.trust.waitingToVerify": "{first} محترفين ينتظرون التحقق.",
  "overview.lede.trust.nothingUrgent": "لا شيء يحتاج قرارًا اليوم.",
  "overview.support.runningOut": "الوقت ينفد",
  "overview.support.soonestFirst": "الأقرب موعدًا أولًا",
  "overview.support.nothingDue": "لا موعد قريب.",
  "overview.support.whereFrom": "من أين وردت",
  "overview.support.noChannels": "لا حالات مفتوحة.",
  "overview.support.channel.chat": "داخل التطبيق",
  "overview.support.channel.phone": "هاتف",
  "overview.support.channel.email": "بريد إلكتروني",
  "overview.support.nobodyOwns": "{count} بلا مسؤول",
  "overview.support.nobodyOwnsWhy": "حالة بلا مسؤول هي حالة لا يردّ عليها أحد. أقدمها منتظرة منذ {days} أيام.",
  "overview.support.takeOldest": "خُذ الأقدم",
  "overview.support.row.mine": "لك",
  "overview.support.row.theirs": "لشخص آخر",
  "overview.support.row.unclaimed": "بلا مسؤول",
  "overview.support.dueInMinutes": "الموعد بعد {minutes} دقيقة",
  "overview.support.dueInHours": "الموعد بعد {hours} ساعات",
  "overview.support.overdue": "تجاوزت موعدها بـ {minutes} دقيقة",
  "overview.figure.toFirstReply": "حتى أول رد",
  "overview.action.reply": "ردّ",
  "overview.action.claim": "خُذها",
  "overview.lede.support.breaching": "{first} حالات على وشك تجاوز موعدها.",
  "overview.lede.support.breachingSomeYours": "{first} حالات على وشك تجاوز موعدها. {second} منها لك.",
  "overview.lede.support.unclaimed": "{first} حالات تنتظر من يتولاها.",
  "overview.lede.support.nothingBreaching": "لا حالة على وشك تجاوز موعدها.",
  "overview.against": "مقابل {month}",
  "overview.title.executive.walliyoMonth": "واليو، {month}",
  "overview.title.people.thingsNeedYou": "{count} أمور تنتظرك",
  "overview.title.people.nothingNeedsYou": "لا شيء ينتظرك",
  "overview.title.support.bonjour": "مرحبًا، {name}",
  "overview.title.trust.safetyToday": "السلامة، اليوم",
  "overview.title.finance.theMoney": "المال، هذا الأسبوع",
  "overview.title.product.themOrUs": "هل السبب منهم أم منّا",
  "overview.title.growth.gettingProsWorking": "تشغيل المحترفين",
  "overview.title.administration.whoMayDoWhat": "من يحق له فعل ماذا",
  "overview.title.marketplace.plain": "نظرة عامة",
  "overview.title.legal.plain": "نظرة عامة",
  "overview.lede.executive.grewFaster": "نما السوق. ونما ما لم يستطع تلبيته أسرع منه.",
  "overview.lede.executive.wentUnanswered": "{first} طلبات بقيت بلا رد هذا الشهر.",
  "overview.lede.executive.quiet": "لم يُنشر شيء هذا الشهر.",
  "overview.lede.executive.holding": "{second} طلبات منشورة، وكل واحد منها وجد ردًا.",
  "overview.people.allClear": "لا شيء ينتظرك. كل شيء تمت معالجته.",
  "overview.people.theCompany": "الشركة",
  "overview.people.employees": "موظفون",
  "overview.people.teams": "فرق",
  "overview.people.yours": "ما يخصك",
  "overview.people.leaveLeft": "الرصيد المتبقي من الإجازات",
  "overview.people.days": "{days} أيام",
  "overview.people.noAllowance": "غير محدد",
  "overview.people.coursesDue": "دورات مستحقة",
  "overview.people.payroll": "الرواتب",
  "overview.people.payrollOpen": "{month} مفتوح. يُغلق بعد {days} أيام.",
  "overview.people.payrollDue": "{month} مفتوح وقد مضى موعد إغلاقه.",
  "overview.people.payrollClosed": "{month} مغلق.",
  "overview.people.linesChecked": "تم التحقق من {checked} من {total} سطرًا",
  "overview.people.task.leave": "{subject} يطلب {count} أيام إجازة",
  "overview.people.detail.leave": "طُلبت قبل {days} أيام · أنت المسؤول عنه",
  "overview.people.task.grantsNoEndDate": "{count} صلاحيات بلا تاريخ انتهاء",
  "overview.people.detail.grantsNoEndDate": "{second} منها تخص أشخاصًا تقودهم",
  "overview.people.task.reviews": "{count} تقييمات عليك كتابتها",
  "overview.people.detail.reviews": "يُغلق في {on}",
  "overview.people.task.starting": "{subject} يبدأ في {on}",
  "overview.people.detail.starting": "الدور مُعيَّن بالفعل",
  "overview.people.task.startingNoRole": "{subject} يبدأ في {on}",
  "overview.people.detail.startingNoRole": "لم يُعيَّن أي دور بعد",
  "overview.action.decide": "قرِّر",
  "overview.action.review": "راجِع",
  "overview.action.write": "اكتب",
  "overview.action.setUp": "جهِّز",
  "overview.action.open": "افتح",
  "overview.hero.jobsPosted": "طلبات منشورة",
  "overview.hero.gotAQuote": "تلقّت عرضاً",
  "overview.hero.fees": "الرسوم، GNF",
  "overview.hero.activePros": "محترفون نشطون",
  "overview.hero.employees": "الموظفون",
  "overview.headline.unanswered": "{count} طلبات بلا ردّ · {second} مهن بلا تغطية",
  "overview.headline.neverQuoted": "{count} محترفين سجّلوا ولم يردّوا قط",
  "overview.headline.breaching": "{count} ملفات تقترب من الموعد · {second} بلا مسؤول",
  "overview.headline.criticalUnreferred": "{count} بلاغات حرجة لم تُحوَّل · {second} تحقّقات منتظرة",
  "overview.headline.approvalsWaiting": "{count} تصحيحات منتظرة · {second} متأخرة",
  "overview.headline.approvalsWaiting.zero": "{count} تصحيحات منتظرة · لا شيء متأخر",
  "overview.headline.grantsWithoutExpiry": "{count} صلاحيات بلا تاريخ انتهاء · {second} طلبات وصول",
  "overview.headline.incidentsOpen": "{count} حادث مفتوح · {second} استدعاءات فاشلة",
  "overview.headline.startingAndPayroll": "{count} قادمون · الرواتب مفتوحة",
  "overview.watch.demandOutrunningSupply":
    "الطلبات ترتفع {first}٪ ونسبة من يحصل على عرض تنخفض {second} نقاط. الطلب يأتي أسرع مما يستطيع العرض الرد عليه.",
  "overview.watch.nobodyAnswered": "{first} طلبات نُشرت ولم يقدّم أحد عرضًا عليها.",
  "roles.new.department": "القسم",
  "roles.new.pickDepartment": "اختر قسماً…",
  "roles.new.departmentNeeded": "اختر قسم الدور: مختبِر الجودة في المنتج والهندسة، والمحاسب في المالية.",
  "screen.experiments": "التجارب",
  "screen.leads": "العملاء المحتملون",
  "screen.campaigns": "الحملات",
  "screen.referrals": "الإحالات",
  "experiments.title": "التجارب",
  "experiments.sub": "تفعيل ميزة لجزء من العملاء والمقارنة.",
  "experiments.loadFailed": "تعذّر تحميل التجارب.",
  "experiments.none": "لا توجد تجارب.",
  "experiments.start": "بدء تجربة",
  "experiments.created": "أُنشئت {reference}",
  "experiments.moved": "{reference} عند {percent}%",
  "experiments.ship": "التعميم",
  "experiments.stop": "الإيقاف",
  "experiments.sticky": "يبقى الشخص في مجموعته: المجموعة تُحسب ولا تُقرع.",
  "experiments.col.name": "التجربة",
  "experiments.col.feature": "الميزة",
  "experiments.col.share": "الحصة",
  "experiments.col.status": "الحالة",
  "experiments.col.ramp": "التوسيع",
  "experiments.status.draft": "مسودة",
  "experiments.status.running": "جارية",
  "experiments.status.stopped": "موقوفة",
  "experiments.status.shipped": "معمّمة",
  "experiments.startTitle": "بدء تجربة",
  "experiments.startBody": "تبدأ من 0%: الإنشاء والفتح قراران.",
  "experiments.startSubmit": "إنشاء",
  "experiments.featureNeeded": "اختر ميزة للعملاء.",
  "experiments.pickFeature": "اختيار…",
  "experiments.field.name": "ما يُجرَّب",
  "experiments.field.feature": "ميزة للعملاء",
  "experiments.field.featureHint": "التجربة تجري على العملاء لا على الموظفين.",
  "experiments.field.metric": "ما يُقاس",
  "experiments.field.metricHint": "يقرؤه إنسان لا الشيفرة.",
  "leads.title": "العملاء المحتملون",
  "leads.sub": "محترفون نريدهم ولا نملكهم بعد.",
  "leads.loadFailed": "تعذّر تحميل العملاء المحتملين.",
  "leads.none": "لا يوجد أحد.",
  "leads.add": "إضافة عميل محتمل",
  "leads.added": "أُضيف {name}",
  "leads.moved": "حُدّث {name}",
  "leads.markContacted": "جرى التواصل",
  "leads.markLost": "خسرناه",
  "leads.nameNeeded": "اذكر اسم المحترف.",
  "leads.status.new": "جديد",
  "leads.status.contacted": "جرى التواصل",
  "leads.status.signed_up": "سجّل",
  "leads.status.lost": "خسرناه",
  "leads.source.coverage_gap": "نقص تغطية",
  "leads.source.referral": "توصية",
  "leads.source.inbound": "وارد",
  "leads.source.other": "أخرى",
  "leads.addTitle": "إضافة عميل محتمل",
  "leads.addBody": "شخص ليس على المنصّة بعد.",
  "leads.addSubmit": "إضافة",
  "leads.field.name": "الاسم",
  "leads.field.phone": "الهاتف",
  "leads.field.trade": "المهنة",
  "leads.field.city": "المدينة",
  "leads.field.source": "المصدر",
  "campaigns.title": "الحملات",
  "campaigns.sub": "رسائل إلى المحترفين والعملاء.",
  "campaigns.loadFailed": "تعذّر تحميل الحملات.",
  "campaigns.none": "لا توجد حملات.",
  "campaigns.draft": "إعداد حملة",
  "campaigns.drafted": "{reference} جاهزة: {count} مستلماً",
  "campaigns.send": "إرسال",
  "campaigns.sent": "أُرسلت إلى {count} شخصاً",
  "campaigns.wentTo": "ذهبت إلى {count}",
  "campaigns.budgetNeeded": "حملة الرسائل القصيرة تحتاج ميزانية.",
  "campaigns.onlyInactive": "فقط من لم يفعلوا شيئاً",
  "campaigns.inAppFree": "مجاني: يصل التنبيه داخل التطبيق.",
  "campaigns.smsCosts": "مدفوع: كل رسالة تكلّف، والبيانات هنا تُدفع بالساعة.",
  "campaigns.smsLength": "{count} حرفاً (فوق 160 رسالتان لكل شخص)",
  "campaigns.channel.in_app": "داخل التطبيق",
  "campaigns.channel.sms": "رسالة قصيرة",
  "campaigns.audience.pros": "المحترفون",
  "campaigns.audience.customers": "العملاء",
  "campaigns.draftTitle": "إعداد حملة",
  "campaigns.draftBody": "يُعاد حساب عدد المستلمين عند الإرسال.",
  "campaigns.draftSubmit": "إعداد",
  "campaigns.field.name": "الاسم",
  "campaigns.field.channel": "القناة",
  "campaigns.field.audience": "المستلمون",
  "campaigns.field.body": "الرسالة",
  "campaigns.field.bodyHint": "بالفرنسية، يراها الجميع.",
  "campaigns.field.budget": "الميزانية (GNF)",
  "campaigns.field.budgetHint": "ما يُسمح بإنفاقه.",
  "referrals.title": "الإحالات",
  "referrals.sub": "محترفون جاء بهم محترفون آخرون.",
  "referrals.loadFailed": "تعذّر تحميل الإحالات.",
  "referrals.none": "لا توجد إحالات.",
  "referrals.unused": "رمز غير مستخدم",
  "referrals.paidOut": "دُفع {amount} {currency}",
  "referrals.paidWhen": "يُدفع عندما يفوز المحترف المُحال بأول عمل له.",
  "referrals.status.open": "مفتوحة",
  "referrals.status.signed_up": "سجّل",
  "referrals.status.rewarded": "مدفوعة",
  "referrals.status.expired": "منتهية",
  "screen.incidents": "الأعطال",
  "incidents.title": "الأعطال",
  "incidents.sub": "ما هو معطّل، وما يُقال للناس عنه.",
  "incidents.loadFailed": "تعذّر تحميل الأعطال.",
  "incidents.openOne": "فتح عُطل",
  "incidents.happeningNow": "جارٍ الآن",
  "incidents.allWell": "كل شيء يعمل.",
  "incidents.over": "منتهية",
  "incidents.open": "فتح",
  "incidents.notAnnounced": "لم يُعلن",
  "incidents.started": "بدأ في {when}",
  "incidents.opened": "فُتح {reference}",
  "incidents.updated": "حُدّث {reference}",
  "incidents.status.open": "مفتوح",
  "incidents.status.monitoring": "تحت المراقبة",
  "incidents.status.resolved": "منتهٍ",
  "incidents.severity.degraded": "متدهور",
  "incidents.severity.down": "متوقّف",
  "incidents.openTitle": "فتح عُطل",
  "incidents.openBody": "ما دام مفتوحاً يرى كل عميل شريطاً. اتركه فارغاً لتتبّع العطل دون إعلان أي شيء.",
  "incidents.openSubmit": "فتح",
  "incidents.titleNeeded": "قل ما هو معطّل، بكلمات قليلة.",
  "incidents.causeNeeded": "قل لماذا حدث قبل الإغلاق.",
  "incidents.updateSubmit": "حفظ",
  "incidents.field.title": "ما هو معطّل",
  "incidents.field.severity": "الخطورة",
  "incidents.field.banner": "رسالة للعملاء",
  "incidents.field.bannerHint": "بالفرنسية، يراها الجميع. فارغ: لا يُبلَّغ أحد.",
  "incidents.field.status": "الحالة",
  "incidents.field.note": "ملاحظة",
  "incidents.field.noteHint": "تُضاف إلى السجل الذي لا يمكن إعادة كتابته.",
  "incidents.field.cause": "السبب",
  "screen.overview": "نظرة عامة",
  "overview.sub": "ما ينتظرك اليوم.",
  "overview.loadFailed": "تعذّر تحميل النظرة العامة.",
  "overview.needsYou": "ما يحتاج إليك",
  "overview.nothingToShow": "لا شيء لعرضه: لا تملك شيئاً مما يطّلع عليه هذا القسم.",
  "overview.waitingDays": "{days} ي انتظاراً",
  "overview.figure.leaveToDecide": "إجازات بانتظار قرارك",
  "overview.figure.reviewsOwed": "تقييمات عليك كتابتها",
  "overview.figure.openRoles": "وظائف مفتوحة",
  "overview.figure.startingSoon": "التحاق هذا الأسبوع",
  "overview.figure.payrollOpen": "كشوف رواتب مفتوحة",
  "overview.figure.leaversStillHolding": "مغادرون ما زالوا يملكون وصولاً",
  "overview.figure.accessRequests": "طلبات وصول",
  "overview.figure.grantsWithoutExpiry": "صلاحيات بلا تاريخ انتهاء",
  "overview.figure.rolesHeldByNobody": "أدوار لا يحملها أحد",
  "overview.figure.staffWithSignIn": "موظفون نشطون",
  "overview.figure.casesBreaching": "ملفات تقترب من الموعد",
  "overview.figure.casesMine": "ملفاتك",
  "overview.figure.casesUnclaimed": "ملفات بلا مسؤول",
  "overview.figure.casesOpen": "ملفات مفتوحة",
  "overview.figure.criticalUnreferred": "بلاغات حرجة لم تُحوَّل",
  "overview.figure.verificationsWaiting": "تحقّقات قيد الانتظار",
  "overview.figure.verificationsOverADay": "منتظرة أكثر من 24 س",
  "overview.figure.reportsOpen": "بلاغات مفتوحة",
  "overview.figure.restrictionsToReview": "قيود تحتاج مراجعة",
  "overview.figure.legalHolds": "حجوزات قانونية",
  "overview.figure.approvalsWaiting": "تصحيحات بانتظار الموافقة",
  "overview.figure.feesThisMonth": "مدفوعات هذا الشهر",
  "overview.figure.creditsOutstanding": "الأرصدة القائمة",
  "overview.figure.subscriptionsEndingSoon": "اشتراكات تنتهي خلال 7 ي",
  "overview.figure.providerEventsFailed": "ردود المزوّد الفاشلة",
  "overview.figure.rulesScheduled": "قواعد مجدولة",
  "overview.figure.featureExceptions": "استثناءات الميزات",
  "overview.figure.prosSignedUp": "محترفون مسجّلون (30 ي)",
  "overview.figure.prosApproved": "محترفون معتمدون (30 ي)",
  "overview.figure.prosNeverQuoted": "محترفون لم يردّوا قط",
  "overview.figure.prosWithWork": "محترفون حصلوا على عمل",
  "overview.figure.promosRunning": "عروض جارية",
  "overview.figure.jobsThisMonth": "طلبات هذا الشهر",
  "overview.figure.customers": "حسابات العملاء",
  "overview.item.caseDueOwned": "ملفك يقترب من الموعد النهائي",
  "overview.item.caseDueUnclaimed": "ملف بلا مسؤول يقترب من الموعد",
  "screen.marketplaceOverview": "نظرة عامة",
  "screen.jobs": "الطلبات",
  "screen.providers": "المحترفون",
  "screen.categories": "المهن",
  "screen.marketplaceReviews": "التقييمات",
  "marketplace.title": "السوق",
  "marketplace.sub": "ما طُلب، ومن يجيده، وأين لا يجيده أحد.",
  "marketplace.loadFailed": "تعذّر تحميل السوق.",
  "marketplace.posted": "طلبات منشورة",
  "marketplace.gotQuote": "تلقّت عرضاً",
  "marketplace.accepted": "مقبولة",
  "marketplace.noBids": "لم يردّ أحد",
  "marketplace.toFirstQuote": "حتى أول عرض",
  "marketplace.hoursShort": "{hours} س",
  "marketplace.nobodyBid": "لم يردّ أحد على هذه",
  "marketplace.nobodyBidHint": "الأقدم أولاً.",
  "marketplace.allAnswered": "كل ما نُشر تلقّى رداً.",
  "marketplace.waitingDays": "{days} ي انتظاراً",
  "marketplace.noProHere": "لا محترف لهذه المهنة هنا",
  "marketplace.prosNearby": "{count} محترفين قريبين",
  "marketplace.demandNoSupply": "طلب بلا عرض",
  "marketplace.demandNoSupplyHint": "طُلب خلال 30 يوماً، ولا محترف للمهنة هناك.",
  "marketplace.everywhereCovered": "كل مدينة فيها محترفون لما تطلبه.",
  "marketplace.activePros": "{count} محترفين يمكنهم العمل اليوم",
  "marketplace.jobs": "الطلبات",
  "marketplace.jobsSub": "كل طلب، وإلى أين وصل.",
  "marketplace.noJobs": "لا طلب مطابق.",
  "marketplace.filter.all": "الكل",
  "marketplace.filter.no_quotes": "بلا عروض",
  "marketplace.filter.requested": "منشورة",
  "marketplace.filter.quoted": "بعروض",
  "marketplace.filter.accepted": "مقبولة",
  "marketplace.filter.cancelled": "ملغاة",
  "marketplace.status.requested": "منشور",
  "marketplace.status.quoted": "بعرض",
  "marketplace.status.accepted": "مقبول",
  "marketplace.status.cancelled": "ملغى",
  "marketplace.status.declined": "مرفوض",
  "marketplace.status.expired": "منتهٍ",
  "marketplace.col.job": "الطلب",
  "marketplace.col.city": "المدينة",
  "marketplace.col.posted": "النشر",
  "marketplace.col.quotes": "العروض",
  "marketplace.col.estimate": "التقدير",
  "marketplace.col.status": "الحالة",
  "marketplace.providers": "المحترفون",
  "marketplace.providersSub": "من يستطيع العمل، ومن لا يعمل بعد.",
  "marketplace.noPros": "لا محترف مطابق.",
  "marketplace.neverQuoted": "لم يردّوا قط",
  "marketplace.allPros": "الجميع",
  "marketplace.unverified": "غير موثّق",
  "marketplace.col.pro": "المحترف",
  "marketplace.col.skills": "المهن",
  "marketplace.col.quotesGiven": "عروض مقدّمة",
  "marketplace.col.rating": "التقييم",
  "marketplace.categories": "المهن",
  "marketplace.categoriesSub": "ما يطلبه الناس، وهل يجيده أحد.",
  "marketplace.noCategories": "لا مهن لعرضها.",
  "marketplace.noDemand": "لا طلب",
  "marketplace.coverageHint": "التغطية هي نسبة الطلبات التي تلقّت عرضاً واحداً على الأقل.",
  "marketplace.col.category": "المهنة",
  "marketplace.col.jobs": "الطلبات",
  "marketplace.col.pros": "المحترفون",
  "marketplace.col.coverage": "التغطية",
  "marketplace.col.uncovered": "مدن بلا محترفين",
  "marketplace.reviews": "التقييمات",
  "marketplace.reviewsSub": "ما يقوله العملاء عن المحترفين.",
  "marketplace.noReviews": "لا تقييم مطابق.",
  "marketplace.poorOnly": "3 نجوم أو أقل",
  "marketplace.allReviews": "الكل",
  "marketplace.averageIs": "المتوسط {average} من {total} تقييماً",
  "nav.group.everyone": "الجميع",
  "workspace.yours": "مساحاتك",
  "department.executive": "الإدارة العليا",
  "department.executive.blurb": "الشركة في لمحة",
  "department.marketplace": "عمليات السوق",
  "department.marketplace.blurb": "الطلبات والمحترفون والفئات",
  "department.support": "خدمة العملاء",
  "department.support.blurb": "الملفات والعملاء والمحترفون",
  "department.trust": "الثقة والسلامة",
  "department.trust.blurb": "التحقق والبلاغات والقيود",
  "department.finance": "المالية",
  "department.finance.blurb": "الرسوم والتصحيحات والاشتراكات",
  "department.growth": "المبيعات والنمو",
  "department.growth.blurb": "استقطاب المحترفين والعروض",
  "department.product": "المنتج والهندسة",
  "department.product.blurb": "الأعطال والقواعد والإطلاقات",
  "department.people": "الموارد البشرية",
  "department.people.blurb": "التوظيف والعمل والرواتب",
  "department.administration": "الإدارة والأمن",
  "department.administration.blurb": "الأدوار والصلاحيات والسجل",
  "department.legal": "الشؤون القانونية والامتثال",
  "department.legal.blurb": "الشروط والبيانات والطلبات القانونية",
  "nav.signedInAs": "متصل باسم",
  "nav.screenCount": "{roles} · الشاشات المتاحة: {visible} من {total}",
  "profile.title": "ملفك الشخصي",
  "profile.open": "افتح ملفك الشخصي",
  "profile.identity": "أنت",
  "profile.email": "البريد الإلكتروني",
  "profile.roles": "الأدوار",
  "profile.permits": "ما تسمح به أدوارك",
  "profile.screensOpen": "{visible} من {total} شاشات متاحة لك",
  "profile.actionCount": "{count} إجراءات متاحة",
  "profile.noPermissions": "لا توجد صلاحيات بحد: لا شيء يحتاج موافقة.",
  "profile.preferences": "التفضيلات",
  "profile.emailLabel": "البريد:",
  "profile.uuidLabel": "UUID:",
  "profile.rolesLabel": "الأدوار",
  "profile.figure.screens": "شاشات مفتوحة لك",
  "profile.figure.actions": "إجراءات يمكنك تنفيذها",
  "profile.figure.ceilings": "بحد أقصى",
  "profile.ceilingHeading": "أقصى ما يمكنك فعله وحدك",
  "profile.ceilingHint": "فوق الحد يظل الإجراء متاحًا — وتتحول محاولتك إلى طلب موافقة.",
  "profile.signOutHint": "ستحتاج إلى تسجيل الدخول مرة أخرى.",
  "header.signOut": "تسجيل الخروج",
  "header.signingOut": "جارٍ تسجيل الخروج…",
  "header.language": "لغة لوحة التحكم",
  "header.theme": "المظهر",
  "header.theme.system": "النظام",
  "header.theme.light": "فاتح",
  "header.theme.dark": "داكن",
  "header.languageNotSaved": "لهذه الجلسة فقط: لم يُحفظ هذا الاختيار في حسابك بعد.",
  "shell.loading": "جارٍ تحميل لوحة التحكم…",
  "shell.loadFailed": "تعذّر تحميل ملفك الشخصي",
  "shell.retry": "إعادة المحاولة",
  "shell.refreshFailed": "تعذّر تحديث صلاحياتك. تعرض لوحة التحكم الصلاحيات المحمّلة في {time}.",
  "shell.noScreens": "لا توجد شاشة متاحة لأدوارك ({roles}). اطلب الوصول من أحد المسؤولين.",
  "shell.noRoles": "لا توجد شاشات متاحة لك بعد. اطلب دورًا من أحد المسؤولين.",
  "connection.retrying": "الاتصال غير مستقر · المحاولة {attempt} من {max}…",

  // ── Screens ──
  "screen.dashboard": "لوحة المتابعة",
  "screen.myRequests": "طلباتي",
  "screen.myTimeOff": "إجازاتي",
  "myTimeOff.sub": "رصيدك، وما طلبته، ومن غيرك غائب.",
  "myRequests.sub": "ما طلبت أن يُسمح لك به، وموقف كل رد.",
  "screen.as.directory": "الدليل",
  "screen.as.market": "السوق",
  "screen.as.employees": "الموظفون",
  "screen.as.recruiting": "التوظيف",
  "screen.as.learning": "التدريب",
  "screen.as.payroll": "الرواتب",
  "screen.as.money": "المال",
  "screen.as.workforce": "القوى العاملة",
  "screen.as.accounts": "الحسابات",
  "screen.cases": "الملفات",
  "screen.customers": "العملاء والمحترفون",
  "screen.verifications": "عمليات التحقق",
  "screen.reports": "البلاغات",
  "screen.billing": "الأسعار والاشتراكات",
  "screen.payments": "المدفوعات",
  "screen.features": "تفعيلات الميزات",
  "screen.userSettings": "إعدادات المستخدم",
  "settings.title": "إعدادات المستخدم",
  "settings.tab.app": "مستخدم التطبيق",
  "settings.tab.employee": "موظف",
  "settings.col.setting": "الإعدادات",
  "settings.default": "القيمة الافتراضية",
  "settings.setHere": "مضبوط لهذا الشخص",
  "settings.clear": "مسح",
  "settings.none": "لا يوجد إعداد مطابق.",
  "screen.actions": "الإجراءات",
  "actions.title": "الإجراءات",
  "actions.col.action": "إجراء",
  "actions.effect.read": "قراءة",
  "actions.effect.write": "كتابة",
  "actions.alsoGates": "+{count} أخرى",
  "actions.col.area": "المجال",
  "actions.col.effect": "الأثر",
  "actions.col.audited": "مُدقَّق",
  "actions.col.needs": "يتطلب",
  "actions.needs.nothing": "لا شيء",
  "actions.yes": "نعم",
  "actions.no": "لا",
  "actions.surface.system": "النظام",
  "actions.search": "ابحث عن إجراء",
  "actions.none": "لا يوجد إجراء مطابق.",
  "screen.permissions": "الصلاحيات",
  "permissions.title": "الصلاحيات",
  "permissions.tab.role": "الدور",
  "permissions.tab.employee": "موظف",
  "permissions.col.limit": "الحد",
  "permissions.col.expires": "ينتهي في",
  "permissions.source.staffRole": "حسب الدور",
  "permissions.source.staffMember": "استثناء",
  "permissions.source.allStaff": "كل الموظفين",
  "permissions.source.default": "لا شيء",
  "permissions.noLimit": "بلا سقف",
  "permissions.featureOff": "الميزة مُعطَّلة",
  "permissions.approvable": "يمكنه الطلب",
  "permissions.pickRole": "اختر دورًا",
  "audit.kind.featureEnablements": "تفعيلات الميزات",
  "audit.kind.permissions": "الصلاحيات",
  "audit.kind.teams": "الأدوار والفِرَق",
  "audit.kind.actions": "الإجراءات",
  "audit.kind.userSettings": "إعدادات المستخدم",
  "screen.roles": "الأدوار",
  "roles.title": "الأدوار",
  "roles.grants.none": "لا يمنح شيئًا بعد",
  "roles.grants.permissions": "تعديل أذوناته",
  "roles.grants.features": "تعديل ميزاته",
  "roles.explain": "ما يُحسنه الشخص ويُؤتمن عليه. الدور نفسه في كل فريق، لذا فالقيادة ليست دورًا — تُضبط من الفِرَق.",
  "roles.col.name": "الدور",
  "roles.col.description": "ما يشمله",
  "roles.col.members": "الأشخاص",
  "roles.none": "لا توجد أدوار بعد.",
  "roles.loading": "جارٍ تحميل الأدوار…",
  "roles.loadFailed": "تعذّرت قراءة الأدوار.",
  "roles.retry": "إعادة المحاولة",
  "roles.edit": "إعادة تسمية",
  "roles.save": "حفظ",
  "roles.cancel": "إلغاء",
  "roles.created": "تم إنشاء الدور.",
  "roles.new": "دور جديد",
  "roles.new.title": "دور جديد",
  "roles.back": "← كل الأدوار",
  "roles.opens": "ما يفتحه",
  "roles.opens.explain":
    "الشاشات التي يبلغها هذا الدور، من العلامات على اليسار. ليست قائمة منفصلة — تظهر الشاشة لأن الدور يملك ما يلزم، والـ API تتحقق من الشيء نفسه.",
  "roles.new.name": "الاسم",
  "roles.new.description": "ما يشمله",
  "roles.new.create": "إنشاء الدور",
  "roles.new.nameNeeded": "أعطِ الدور اسمًا.",
  "roles.new.grantsNeeded": "اختر ما الغرض من الدور: دور لا يمنح شيئًا لا أثر له.",
  "roles.new.grants": "ما يمكنه استخدامه",
  "roles.new.permissions": "ما يُسمح له به",
  "roles.lock.critical": "لا يمنح هذا إلا Owner.",
  "roles.lock.high": "لا تمنح إلا ما تملكه أنت.",
  "roles.lock.readOnly": "لا يمكنك المنح على دور.",
  "roles.lock.featureFirst": "فعّل أولاً ما يقوم عليه.",
  "screen.teams": "الفِرَق",
  "teams.title": "الفِرَق",
  "teams.col.name": "الفريق",
  "teams.col.purpose": "ما الذي يقوم به",
  "teams.col.lead": "يقوده",
  "teams.col.members": "الأشخاص",
  "teams.col.status": "الحالة",
  "teams.col.person": "الشخص",
  "teams.col.roles": "الدور",
  "teams.col.onTeam": "ضمن الفريق",
  "teams.col.leads": "يقوده",
  "teams.open": "فتح",
  "teams.back": "كل الفِرَق",
  "teams.none": "لا توجد فِرَق بعد.",
  "teams.noMembers": "لا أحد في هذا الفريق بعد.",
  "teams.noOthers": "الجميع في هذا الفريق بالفعل.",
  "teams.loading": "جارٍ تحميل الفِرَق…",
  "teams.loadFailed": "تعذّرت قراءة الفِرَق.",
  "teams.retry": "إعادة المحاولة",
  "teams.status.open": "مفتوح",
  "teams.status.closed": "مغلق",
  "teams.rename": "إعادة تسمية",
  "teams.close": "إغلاق الفريق",
  "teams.reopen": "إعادة فتحه",
  "teams.closedReason": "مغلق",
  "teams.reopenedReason": "أُعيد فتحه",
  "teams.closedNote": "مغلق. يبقى الجميع فيه: عند إعادة فتحه تجدهم كما هم.",
  "teams.new": "فريق جديد",
  "teams.explain":
    "مجموعة من الأشخاص يؤدون العمل نفسه، مع قائد. العمل يصل إلى الفريق لا إلى شخصِ، ومن كان في الخدمة اليوم يأخذ التالي. الفريق لا يمنح شيئًا.",
  "teams.new.people":
    "من فيه منذ إنشائه. اختر «يقوده» لتقول لمن هؤلاء الأشخاص: يعيد توزيع عمل الفريق ويحلّ محل أي منهم.",
  "teams.new.name": "الاسم",
  "teams.new.purpose": "ما الذي يقوم به",
  "teams.new.create": "إنشاء الفريق",
  "teams.new.cancel": "إلغاء",
  "teams.new.nameNeeded": "أعطِ الفريق اسمًا.",
  "teams.nameTaken": "يوجد فريق بهذا الاسم بالفعل.",
  "teams.created": "تم إنشاء الفريق.",
  "teams.leadHint": "هؤلاء أشخاصه: يعيد توزيع عمل الفريق ويحلّ محل أي منهم.",
  "teams.leadNeedsMember": "لا يقود الفريق إلا من كان ضمنه.",
  "teams.noLead": "بلا قائد",
  "teams.gone": "من غادر لا يمكن إضافته إلى فريق.",
  "teams.locked": "لا يمكنك تعديل الفِرَق.",
  "screen.rules": "القواعد",
  "screen.hr": "الموارد البشرية",
  "sub.hr": "ابحث عن أي شخص. التوظيف والملفات وكل ما تحتها للموارد البشرية.",
  "screen.team": "الأدوار والفريق",
  "screen.audit": "تدقيقات Walliyo",

  // ── Locked screen (opened by URL without the feature) ──
  "lock.requires": "تتطلب هذه الشاشة",
  "lock.or": " أو ",
  "lock.roles": "أدوارك ({roles}) لا تشملها، لذلك لا تظهر في قائمتك.",
  "lock.noRoles": "ليس لديك أي دور، لذلك لا تظهر في قائمتك.",

  // ── Sign-in ──
  "signIn.title": "تسجيل الدخول إلى لوحة التحكم",
  "signIn.subtitle": "مخصصة لفريق Walliyo. سيصلك رمز عبر SMS.",
  "signIn.email": "البريد الإلكتروني المهني",
  "signIn.password": "كلمة المرور",
  "signIn.submit": "متابعة",
  "signIn.submitting": "جارٍ التحقق…",
  "verify.title": "رمز التحقق",
  "verify.subtitle": "أرسلنا رمزًا عبر SMS إلى {phone}.",
  "verify.code": "الرمز المستلم عبر SMS",
  "verify.submit": "تسجيل الدخول",
  "verify.submitting": "جارٍ التحقق…",
  "verify.expiresIn": "تنتهي صلاحية الرمز خلال {time}.",
  "verify.expired": "انتهت صلاحية الرمز. أعد تسجيل الدخول لتتلقى رمزًا جديدًا.",
  "verify.restart": "إعادة تسجيل الدخول",

  // ── Errors: what failed and what to do (ADR-0016 §2.5) ──
  "error.requestId": "معرّف الطلب: {id}",
  "error.noRequestId": "لا يوجد معرّف طلب: لم يستجب الخادم.",
  "error.signIn.unauthenticated": "البريد الإلكتروني أو كلمة المرور غير صحيحة. تحقق منهما وأعد المحاولة.",
  "error.signIn.validation_error": "أدخل بريدًا إلكترونيًا وكلمة مرور صالحين.",
  "error.verify.validation_error": "أدخل الرمز المكوّن من 6 أرقام الذي وصلك عبر SMS.",
  "error.verify.session_expired": "انتهت صلاحية الرمز. أعد تسجيل الدخول لتتلقى رمزًا جديدًا.",
  "error.verify.unauthenticated": "طلب الرمز هذا لم يعد صالحًا. أعد تسجيل الدخول.",
  "error.unauthenticated": "لم تعد متصلًا. سجّل الدخول مجددًا.",
  "error.session_expired": "انتهت جلستك. سجّل الدخول مجددًا.",
  "error.feature_not_enabled": "أدوارك لا تسمح بهذا الإجراء. اطلب الوصول من أحد المسؤولين.",
  "error.invalid_code": "الرمز غير صحيح. تحقق من الرسالة وأدخل الرمز مجددًا.",
  "error.too_many_attempts": "محاولات كثيرة جدًا. انتظر بضع دقائق ثم أعد تسجيل الدخول.",
  "error.stale_version": "تغيّر هذا العنصر أثناء اطلاعك عليه. أعد التحميل لرؤية النسخة الحالية.",
  "error.validation_error": "بعض المعلومات غير صالحة. صحّحها وأعد المحاولة.",
  "error.internal_error": "حدث خطأ في الخادم. أعد المحاولة؛ وإن استمر، أرسل المعرّف أدناه إلى الفريق التقني.",
  "error.network_error": "لا استجابة من الخادم بعد عدة محاولات. تحقق من اتصالك ثم أعد المحاولة.",
  "error.network_error.write": "لا استجابة من الخادم: ربما نُفّذ الطلب. أعد المحاولة، ولن يُنفّذ مرتين.",
  "error.unexpected_response":
    "استجابة غير متوقعة من الخادم. أعد المحاولة؛ وإن استمر، أرسل المعرّف أدناه إلى الفريق التقني.",
  "error.unknown": "حدث خطأ غير متوقع في لوحة التحكم. أعد تحميل الصفحة؛ وإن استمر، أبلغ الفريق التقني.",

  "sub.cases": "قائمة مشتركة · المكالمات والبريد الإلكتروني والدردشة في مكان واحد",

  "sub.customers": "ابحث عن عميل أو محترف واطّلع على حسابه كاملًا",

  "sub.verifications": "التحقق من هوية المحترفين قبل أن يظهروا في البحث",

  "sub.reports": "بلاغات بشأن محترفين أو عملاء، حسب الخطورة",

  "sub.billing": "الأسعار حسب البلد والعروض والتخفيضات · يحتفظ المهني بالسعر الذي اشترك به",
  "sub.payments": "رسوم المحترفين · Orange Money والبطاقة",

  "sub.features": "التفعيل أو التعطيل حسب المستوى: الجميع، منطقة، إصدار، شخص",

  "sub.rules": "قيم الشركة · كل تعديل ينشئ نسخة جديدة",

  // ── Fonctionnalités ──
  "features.title": "تفعيلات الميزات",
  "features.loading": "جارٍ تحميل الميزات…",
  "features.loadFailed": "تعذّر تحميل الميزات.",
  "features.retry": "إعادة المحاولة",
  "features.close": "إغلاق",
  "features.pick": "اختر ميزة لعرض استثناءاتها.",
  "features.notFound": "هذه الميزة غير موجودة أو لم تعد موجودة. اختر واحدة من القائمة.",
  "features.subject.for": "سجل",
  "features.subject.allClients": "كل العملاء",
  "features.subject.allPros": "كل المحترفين",
  "features.subject.user": "مستخدم",
  "features.subject.uuid": "UUID",
  "features.subject.uuidHint": "31290388",
  "features.subject.unknown": "لم يُعثر على UUID.",
  "features.kind.client": "عميل",
  "features.kind.pro": "محترف",
  "features.col.source": "المصدر",
  "features.col.value": "القيمة",
  "features.col.category": "الفئة",
  "features.value.on": "مُفعَّل",
  "features.value.off": "مُعطَّل",
  "features.source.default": "الافتراضي",
  "features.source.thisUser": "هذا المستخدم",
  "features.source.user": "مستخدم واحد",
  "features.source.allClients": "كل العملاء",
  "features.source.allPros": "كل المحترفين",
  "features.source.proProfile": "ملف محترف",
  "features.source.region": "المنطقة",
  "features.source.appVersion": "إصدار التطبيق",
  "features.source.system": "النظام",
  "features.locked.owner": "لا يغيّرها إلا Owner",
  "features.locked.scope": "غير قابلة للضبط على هذا المستوى",
  "features.save.discard": "تجاهل",
  "features.save.sending": "جارٍ الحفظ…",
  "features.save.nothing": "لا شيء للحفظ: لم يتغيّر شيء.",
  "features.save.locked": "أحد التغييرات ليس من صلاحيتك.",
  "features.save.reasonNeeded": "اذكر السبب بكلمات قليلة.",
  "features.save.leave": "لديك تغييرات غير محفوظة.",
  "features.clear": "العودة إلى القيمة الموروثة",
  "features.cleared": "سيُمسح",
  "features.filter.any": "الكل",
  "features.filter.own": "مضبوطة هنا",
  "features.filter.inherited": "موروثة",
  "features.filter.search": "بحث",
  "features.filter.none": "لا توجد ميزة تطابق هذه المرشّحات.",
  "features.surface.app": "تطبيق Walliyo",
  "features.surface.console": "وحدة تحكم Walliyo",
  "features.save.title.one": "تغيير واحد غير محفوظ",
  "features.save.title.many": "{count} تغييرات غير محفوظة",
  "features.save.submit.one": "حفظ تغيير واحد",
  "features.save.submit.many": "حفظ {count} تغييرات",
  "features.save.done.one": "تم حفظ تغيير واحد.",
  "features.save.done.many": "تم حفظ {count} تغييرات.",
  "features.unsaved": "غير محفوظ",
  "features.surface.consoleSoon": "ميزات وحدة التحكم الـ{count} تُضبط حتى الآن حسب الدور فقط. الضبط لكل شخص سيأتي هنا.",
  "features.surface.consoleWhere": "فتح الأدوار والفريق",
  "features.subject.isStaff": "هذا الرقم يخص موظفًا في Walliyo. ميزاته في تبويب وحدة تحكم Walliyo.",
  "features.subject.search": "بحث",
  "features.subject.searching": "جارٍ البحث…",
  "features.subject.needsUuid": "اكتب خانات الـ UUID الثماني.",
  "features.subject.pickFirst": "اختر لمن، ثم ابحث.",
  "features.subject.stale": "هذه النتائج من بحثك السابق. ابحث مرة أخرى لتحديثها.",
  "features.pill.allClients": "كل سجلات العملاء",
  "features.pill.allPros": "كل سجلات المحترفين",
  "features.pill.unknown": "مستخدم غير معروف",
  "features.pill.staff": "موظف Walliyo",
  "features.subject.allStaff": "كل الموظفين",
  "features.subject.staffMember": "موظف",
  "features.staffSource.override": "استثناء",
  "features.staffSource.byRole": "حسب الدور",
  "features.staffSource.byRoleNamed": "حسب الدور: {roles}",
  "features.staffSource.allStaff": "كل الموظفين",
  "features.locked.ownAccount": "لا يمكنك تغيير حسابك",
  "features.locked.grant": "لا يمكنك منح هذه",
  "features.pill.allStaff": "كل سجلات الموظفين",
  "features.pill.unknownStaff": "موظف غير معروف",
  "features.subject.isCustomer": "هذا الرقم يخص عميلًا لا موظفًا. ميزاته في تبويب تطبيق Walliyo.",
  "features.subject.employeeUuid": "UUID الموظف",
  "features.subject.staffUuidHint": "27217102",
  "features.col.feature": "الميزة",
  "features.col.default": "الافتراضي",
  "features.col.exceptions": "الاستثناءات",
  "features.for.clients": "للعملاء",
  "features.for.pros": "للمحترفين",
  "features.for.everyone": "للجميع",
  "features.on": "مفعّل",
  "features.off": "معطّل",
  "features.planned": "مخطط لها",
  "features.planned.note": "مخطط لها: يمكن تعيين قيمة، لكن لا توجد شيفرة تقرؤها بعد.",
  "features.detail.default": "الافتراضي: {value}",
  "features.sensitivity.open": "حساسية {level}: يمكن لأي شخص يدير ميزات التطبيق تغييرها.",
  "features.sensitivity.critical": "حساسية حرجة: لا يغيّرها إلا مالك، ويُبلَّغ المالكون.",
  "features.locked.critical":
    "مقفلة: هذه الميزة حرجة ولا يغيّرها إلا مالك. أدوارك ({roles}) لا تجعلك مالكًا؛ وسيرفض الخادم أيضًا.",
  "features.exceptions.title": "الاستثناءات حسب المستوى",
  "features.col.scope": "المستوى",
  "features.col.target": "الهدف",
  "features.col.reason": "السبب",
  "features.col.expires": "ينتهي",
  "features.col.actions": "إدارة",
  "features.default.scope": "الافتراضي",
  "features.default.reason": "القيمة الافتراضية",
  "features.exceptions.none": "لا توجد استثناءات: تنطبق القيمة الافتراضية على الجميع.",
  "features.expired": "منتهية",
  "features.expires.never": "حتى التغيير",
  "features.edit": "تعديل",
  "features.remove": "إزالة",
  "features.add": "إضافة استثناء",
  "features.scope.system": "النظام",
  "features.scope.allClients": "كل العملاء",
  "features.scope.allPros": "كل المحترفين",
  "features.scope.region": "المنطقة",
  "features.scope.appVersion": "إصدار التطبيق",
  "features.scope.user": "شخص واحد",
  "features.scope.proProfile": "ملف محترف واحد",
  "features.scope.clientProfile": "ملف عميل واحد",
  "features.target.everyone": "الجميع",
  "features.target.allClients": "كل العملاء",
  "features.target.allPros": "كل المحترفين",
  "features.target.appVersion": "الإصدار {version} وما بعده",
  "features.target.unnamed": "حساب بلا اسم",
  "features.form.addTitle": "استثناء جديد",
  "features.form.editTitle": "تعديل الاستثناء",
  "features.form.scope": "المستوى",
  "features.form.scopePick": "اختر مستوى…",
  "features.form.scopeUnsupported": "{scope} (غير ممكن بعد)",
  "features.form.clientProfileNote":
    "لا يمكن بعدُ تعيين قيمة لملف عميل: ملفات العملاء غير موجودة بعد. لعميل واحد، اختر «شخص واحد».",
  "features.form.needsSearch": "يتطلب اختيار شخص أو ملف محترف",
  "features.form.needsView": "يتطلب العثور على ملف المحترف لحساب ما",
  "features.form.region": "المنطقة",
  "features.form.regionPick": "اختر منطقة…",
  "features.form.appVersion": "بدءًا من الإصدار",
  "features.form.appVersionHint": "مثلًا 2.4.0: ينطبق على هذا الإصدار وما بعده.",
  "features.form.person": "الشخص",
  "features.form.pro": "ملف المحترف",
  "features.form.search": "بحث",
  "features.form.searching": "جارٍ البحث…",
  "features.form.searchPlaceholder": "الاسم أو الهاتف أو البريد أو معرّف الحساب",
  "features.form.noResults": "لا يوجد حساب مطابق.",
  "features.form.pickedChange": "تغيير",
  "features.form.value": "القيمة",
  "features.form.reason": "السبب (إلزامي)",
  "features.form.reasonHint": "يُسجَّل في سجل التدقيق مع التغيير.",
  "features.form.expires": "ينتهي في",
  "features.form.expiresHint": "اختياري. فارغ: حتى التغيير.",
  "features.form.version": "مبنية على النسخة {version} من هذا الاستثناء.",
  "features.form.submitAdd": "إضافة الاستثناء",
  "features.form.submitEdit": "حفظ",
  "features.form.cancel": "إلغاء",
  "features.form.sending": "جارٍ الإرسال…",
  "features.problem.scope": "اختر أحد المستويات المعروضة.",
  "features.problem.region": "اختر منطقة.",
  "features.problem.appVersion": "أدخل إصدارًا مثل 2.4.0.",
  "features.problem.person": "ابحث عن الشخص واختره من النتائج.",
  "features.problem.pro": "ابحث عن المحترف واختر حسابًا له ملف محترف.",
  "features.problem.exists": "يوجد استثناء لهذا الهدف بالفعل: عدّله بدلًا من ذلك.",
  "features.problem.reason": "اذكر السبب في بضع كلمات.",
  "features.problem.expiryInvalid": "تاريخ الانتهاء هذا غير صالح.",
  "features.problem.expiryPast": "يجب أن يكون تاريخ الانتهاء في المستقبل، أو اتركه فارغًا.",
  "features.refused.critical": "مرفوض: هذه الميزة حرجة، ولا يغيّرها إلا مالك.",
  "features.refused.scopeNotSupported":
    "مرفوض: لا يمكن بعدُ تعيين قيمة لملف عميل، فملفات العملاء غير موجودة بعد. اختر «شخص واحد».",
  "features.refused.scopeNotAllowed": "مرفوض: لا يمكن ضبط هذه الميزة على هذا المستوى. اختر أحد المستويات المعروضة.",
  "features.refused.expiryInPast": "مرفوض: تاريخ الانتهاء في الماضي. اختر تاريخًا لاحقًا، أو اتركه فارغًا.",
  "features.refused.targetNotFound": "مرفوض: هذا الحساب أو ملف المحترف لم يعد موجودًا. ابحث عنه مجددًا.",
  "features.stale": "غيّر أحدهم هذه الميزة في هذه الأثناء. أعد التحميل لرؤية استثناءاتها الحالية، ثم أعد المحاولة.",
  "features.done.added": "أُضيف الاستثناء.",
  "features.done.saved": "حُفظ الاستثناء.",
  "features.done.removed": "أُزيل الاستثناء: يعود تطبيق المستوى الأوسع أو القيمة الافتراضية.",
  "features.remove.title": "إزالة الاستثناء",
  "features.remove.body":
    "إزالة الاستثناء «{scope} · {target}: {value}» من {feature}. سيعود تطبيق المستوى الأوسع أو القيمة الافتراضية.",
  "features.remove.submit": "إزالة",

  // ── Règles ──
  "rules.loading": "جارٍ تحميل القواعد…",
  "rules.loadFailed": "تعذّر تحميل القواعد.",
  "rules.retry": "إعادة المحاولة",
  "rules.pick": "اختر قاعدة لعرض سجلها.",
  "rules.notFound": "هذه القاعدة غير موجودة. اختر واحدة من القائمة.",
  "rules.next": "اعتبارًا من {date}: {value}",
  "rules.now": "السارية الآن",
  "rules.default": "القيمة الافتراضية",
  "rules.kind.gnf": "مبلغ بالفرنك الغيني (GNF)",
  "rules.kind.minutes": "مدة بالدقائق",
  "rules.kind.hours": "مدة بالساعات",
  "rules.kind.days": "مدة بالأيام",
  "rules.kind.km": "مسافة بالكيلومتر",
  "rules.kind.number": "رقم",
  "rules.kind.boolean": "نعم أو لا",
  "rules.kind.choice": "اختيار من قائمة",
  "rules.kind.text": "نص",
  "rules.sensitivity.open": "حساسية {level}: يمكن لأي شخص يعدّل القواعد إنشاء نسخة.",
  "rules.sensitivity.critical": "حساسية حرجة: لا ينشئ نسخة إلا مالك.",
  "rules.legalBasis.required": "يجب أن يذكر كل تغيير أساسه القانوني.",
  "rules.locked.critical":
    "مقفلة: هذه القاعدة حرجة ولا ينشئ نسخة منها إلا مالك. أدوارك ({roles}) لا تجعلك مالكًا؛ وسيرفض الخادم أيضًا.",
  "rules.locked.retired": "هذه القاعدة متقاعدة: لم يعد شيء يقرؤها، فلا يمكن تغييرها.",
  "rules.history": "سجل النسخ",
  "rules.history.none": "لا توجد نسخ: تنطبق القيمة الافتراضية ({value}).",
  "rules.col.version": "رقم النسخة",
  "rules.col.value": "القيمة",
  "rules.col.effective": "السريان",
  "rules.col.reason": "السبب",
  "rules.col.legalBasis": "الأساس القانوني",
  "rules.col.by": "بواسطة",
  "rules.status.scheduled": "اعتبارًا من {date}",
  "rules.status.current": "الحالية",
  "rules.status.since": "منذ {date}",
  "rules.status.past": "مستبدلة",
  "rules.new": "نسخة جديدة",
  "rules.form.title": "نسخة جديدة",
  "rules.form.value": "القيمة الجديدة",
  "rules.form.value.gnf": "المبلغ الجديد (GNF)",
  "rules.form.value.minutes": "القيمة الجديدة (بالدقائق)",
  "rules.form.value.hours": "القيمة الجديدة (بالساعات)",
  "rules.form.value.days": "القيمة الجديدة (بالأيام)",
  "rules.form.effective": "بدء السريان",
  "rules.form.now": "الآن",
  "rules.form.at": "في تاريخ ووقت محددين",
  "rules.form.atLabel": "يسري في",
  "rules.form.reason": "السبب (إلزامي)",
  "rules.form.legalBasis": "الأساس القانوني (إلزامي)",
  "rules.form.legalBasisOptional": "الأساس القانوني (إن وُجد)",
  "rules.form.legalBasisPlaceholder": "قانون، عقد، استشارة قانونية",
  "rules.form.version": "مبنية على النسخة {version} من القاعدة: إذا أُضيفت نسخة أخرى في هذه الأثناء فسيُرفض الإرسال.",
  "rules.form.submit": "إنشاء النسخة",
  "rules.form.cancel": "إلغاء",
  "rules.form.sending": "جارٍ الإرسال…",
  "rules.value.true": "نعم",
  "rules.value.false": "لا",
  "rules.problem.value": "أدخل قيمة.",
  "rules.problem.number": "أدخل رقمًا، مثلًا 750000.",
  "rules.problem.integer": "أدخل عددًا صحيحًا.",
  "rules.problem.min": "يجب ألا تقل القيمة عن {min}.",
  "rules.problem.max": "يجب ألا تزيد القيمة على {max}.",
  "rules.problem.choice": "اختر قيمة من القائمة.",
  "rules.problem.tooLong": "{max} حرفًا على الأكثر.",
  "rules.problem.effectiveMissing": "اختر تاريخ ووقت بدء السريان.",
  "rules.problem.effectivePast":
    "لا يمكن أن تسري نسخة في الماضي: ما كان ساريًا حينها يبقى مسجلًا. اختر الآن أو لاحقًا.",
  "rules.problem.reason": "اذكر السبب في بضع كلمات.",
  "rules.problem.legalBasis": "اذكر القانون أو العقد أو الاستشارة القانونية وراء هذا التغيير.",
  "rules.refused.critical": "مرفوض: هذه القاعدة حرجة، ولا ينشئ نسخة منها إلا مالك.",
  "rules.refused.effectivePast": "مرفوض: هذا التاريخ في الماضي. اختر الآن أو لاحقًا.",
  "rules.refused.legalBasis": "مرفوض: تتطلب هذه القاعدة أساسًا قانونيًا. اذكر القانون أو العقد أو الاستشارة القانونية.",
  "rules.refused.invalidValue": "مرفوض: هذه القيمة لا تناسب القاعدة. تحقق من الوحدة والحد الأدنى.",
  "rules.refused.retired": "مرفوض: هذه القاعدة متقاعدة، ولم يعد شيء يقرؤها.",
  "rules.stale": "أُضيفت نسخة أخرى من هذه القاعدة في هذه الأثناء. أعد التحميل لرؤيتها، ثم أعد المحاولة.",
  "rules.done.now": "أُنشئت النسخة {version}: تسري الآن.",
  "rules.done.scheduled": "أُنشئت النسخة {version}: تسري اعتبارًا من {date}.",

  "sub.team": "كل دور هو قائمة من الميزات. لا يمكن لأحد أن يمنح نفسه أي شيء.",

  "sub.audit": "كل ما تم، ومن قام به، ولمن · اطلاعك نفسه مُسجَّل",

  // ── Audit log ──
  "audit.filter.subject": "الشخص المعني",
  "audit.filter.subjectPlaceholder": "معرّف الحساب",
  "audit.filter.staff": "عضو الفريق",
  "audit.filter.staffPlaceholder": "معرّف العضو",
  "audit.filter.action": "الإجراء",
  "audit.filter.area": "المجال",
  "audit.filter.outcome": "النتيجة",
  "audit.filter.from": "من",
  "audit.filter.to": "إلى (ضمنًا)",
  "audit.filter.all": "الكل",
  "audit.filter.allActions": "الكل",
  "audit.filter.clear": "مسح عوامل التصفية",
  "audit.problem.id": "المعرّف بالشكل 3f2a…-…-…-…-… (UUID). انسخه من صفحة الحساب.",
  "audit.problem.period": "نهاية الفترة تسبق بدايتها.",
  "audit.problem.needsPerson": "أدخل UUID المُعدِّل أو UUID الشخص أو كليهما.",
  "audit.filtersAria": "عوامل تصفية السجل",
  "audit.searchAria": "البحث في السجل",
  "audit.scope.user": "فرد",
  "audit.scope.allStaff": "كل الموظفين",
  "audit.scope.allClients": "كل العملاء",
  "audit.scope.allPros": "كل المحترفين",
  "audit.scope.staffRole": "دور",
  "audit.scope.proProfile": "ملف محترف",
  "audit.scope.region": "المنطقة",
  "audit.scope.appVersion": "إصدار التطبيق",
  "audit.scope.system": "النظام",
  "audit.scope.staffMember": "فرد",
  "audit.filter.involving": "يخص",
  "audit.filter.updaterUuid": "UUID المُعدِّل",
  "audit.filter.userUuid": "UUID الشخص",
  "audit.pill.updater": "المُعدِّل",
  "audit.pill.user": "الشخص",
  "audit.col.time": "الوقت",
  "audit.col.actor": "المُعدِّل",
  "audit.col.action": "الإعداد",
  "audit.col.subject": "يخص",
  "audit.col.outcome": "النتيجة",
  "audit.col.reason": "السبب",
  "audit.filter.effect": "عرض",
  "audit.effect.write": "التغييرات",
  "audit.effect.read": "الاطلاعات",
  "audit.col.before": "قبل",
  "audit.col.after": "بعد",
  "audit.change.arrow": "{before} ← {after}",
  "audit.change.field": "{key}: {value}",
  "audit.outcome.succeeded": "نجح",
  "audit.outcome.denied": "مرفوض",
  "audit.outcome.requested": "مطلوب",
  "audit.actor.staff": "عضو الفريق",
  "audit.actor.noRoles": "بلا دور",
  "audit.actor.customer": "عميل",
  "audit.actor.self": "عميل (بنفسه)",
  "audit.actor.system": "النظام",
  "audit.subject.onBehalf": "نيابةً عن {id}",
  "audit.filterBy": "التصفية حسب {id}",
  "audit.subject.open": "فتح حساب {name}",
  "audit.masked": "مخفي",
  "audit.sensitive": "🔒 حساس",
  "audit.loading": "جارٍ تحميل السجل…",
  "audit.loadFailed": "تعذّر تحميل السجل.",
  "audit.retry": "إعادة المحاولة",
  "audit.empty": "لا توجد إدخالات تطابق عوامل التصفية هذه.",
  "audit.emptyForPerson": "لا يوجد أي سجل لهذا البحث.",
  "audit.fixProblems": "صحّح عوامل التصفية المشار إليها لعرض السجل.",
  "audit.loadMore": "تحميل المزيد",
  "audit.loadingMore": "جارٍ التحميل…",
  "audit.moreFailed": "تعذّر تحميل الصفحة التالية. تبقى الإدخالات المعروضة صالحة.",
  "audit.count": "عدد الإدخالات المعروضة: {count}",
  "audit.countOne": "إدخال واحد معروض",
  "audit.end": "نهاية السجل لعوامل التصفية هذه.",
  "audit.recorded": "اطلاعك نفسه مُسجَّل (VIEW_AUDIT_LOG_STAFF_ACTION)، مع عوامل التصفية المستخدمة.",
  "audit.sensitiveShown": "أنت ترى القيم الحساسة (VIEW_SENSITIVE_AUDIT_VALUES).",
  "audit.sensitiveHidden": "القيم الحساسة مخفية: يلزم VIEW_SENSITIVE_AUDIT_VALUES، ولا يمنحه إلا المالك.",
  "audit.deniedNote": "يوضح السطر «مرفوض» أن أي محاولة دون صلاحية تُسجَّل أيضًا.",
  "area.account": "الحساب",
  "area.access": "الوصول",
  "area.onboarding": "تسجيل المحترفين",
  "area.discovery": "البحث",
  "area.jobs": "الطلبات",
  "area.leads": "الفرص",
  "area.messaging": "الرسائل",
  "area.reviews": "التقييمات",
  "area.payments": "المدفوعات",
  "area.support": "الملفات",
  "area.safety": "الأمان",
  "area.settings": "الإعدادات",
  "area.staff": "الفريق",
  "area.audit": "التدقيق",

  // ── Roles & team ──
  "team.members": "الفريق",
  "team.col.name": "الاسم",
  "team.col.roles": "الأدوار",
  "team.col.status": "الحالة",
  "team.col.lastSeen": "آخر اتصال",
  "team.you": "أنت",
  "team.noRoles": "بلا دور",
  "team.status.active": "نشط",
  "team.status.invited": "مدعو",
  "team.status.deactivated": "معطّل",
  "team.sessions": "الجلسات المفتوحة: {count}",
  "team.sessionsOne": "جلسة واحدة مفتوحة",
  "team.lastSeen.never": "لم يتصل قط",
  "team.lastSeen.today": "اليوم عند {time}",
  "team.lastSeen.yesterday": "أمس عند {time}",
  "team.lastSeen.date": "في {date}",
  "team.invite": "دعوة",
  "team.manageRoles": "الأدوار",
  "team.endSessions": "إنهاء الجلسة",
  "team.deactivate": "تعطيل",
  "team.loading": "جارٍ تحميل الفريق…",
  "team.loadFailed": "تعذّر تحميل الفريق.",
  "team.retry": "إعادة المحاولة",
  "team.emptyStaff": "لا يوجد أحد في الفريق حاليًا.",
  "team.grid": "الأدوار × الميزات",
  "team.grid.feature": "الميزة",
  "team.grid.editable": "انقر للمنح أو السحب · «critical» يتطلب المالك",
  "team.grid.readOnly": "🔒 للقراءة فقط · التعديل يتطلب MANAGE_ROLES أو ASSIGN_ROLES",
  "team.grid.members": "عدد الأعضاء: {count}",
  "team.grid.membersOne": "عضو واحد",
  "team.grid.yourRole": "🔒 دورك",
  "team.grid.newRole": "دور جديد",
  "team.grid.editRole": "تعديل",
  "team.grid.noRoles": "لا يوجد أي دور بعد.",
  "team.lock.ownRole": "لديك هذا الدور: لا أحد يعدّل ما يمنحه دوره هو.",
  "team.lock.critical": "حرجة: لا يمنحها أو يسحبها إلا المالك.",
  "team.lock.high": "حساسية عالية: يلزم MANAGE_ROLES وأن تملك هذه الميزة بنفسك.",
  "team.lock.low": "يلزم MANAGE_ROLES أو ASSIGN_ROLES.",
  "team.lock.criticalShort": "🔒 المالك",
  "team.lock.highShort": "🔒 خارج صلاحياتك",
  "team.cell.grant": "منح {feature} للدور {role}",
  "team.cell.revoke": "سحب {feature} من الدور {role}",
  "team.sensitivity.low": "low",
  "team.sensitivity.high": "high",
  "team.sensitivity.critical": "critical",

  "team.reason": "السبب",
  "team.reasonHint": "يُسجَّل في سجل التدقيق. تكفي بضع كلمات.",
  "team.reasonTooShort": "اذكر سببًا من 3 أحرف على الأقل.",
  "team.cancel": "إلغاء",
  "team.close": "إغلاق",
  "team.sending": "جارٍ الإرسال…",
  "team.reload": "إعادة التحميل",
  "team.refused": "مرفوض: {message}",
  "team.stale": "عدّل أحدهم هذا في الأثناء. أعد التحميل لرؤية النسخة الحالية، ثم أعد المحاولة.",

  "team.grant.title": "منح ميزة",
  "team.revoke.title": "سحب ميزة",
  "team.grant.body": "منح {feature} للدور {role} ({members}).",
  "team.revoke.body": "سحب {feature} من الدور {role} ({members}).",
  "team.grant.submit": "منح",
  "team.revoke.submit": "سحب",
  "team.grant.done": "مُنحت {feature} للدور {role}.",
  "team.revoke.done": "سُحبت {feature} من الدور {role}.",
  "team.critical.note": "ميزة حرجة: سيُبلَّغ المالكون.",

  "team.invite.title": "دعوة عضو إلى الفريق",
  "team.invite.name": "الاسم الكامل",
  "team.invite.email": "البريد الإلكتروني المهني",
  "team.invite.phone": "الهاتف",
  "team.invite.phoneHint": "بالصيغة الدولية، مثل +224621234567.",
  "team.invite.roles": "الأدوار",
  "team.invite.noRoles": "أنشئ دورًا أولًا — يمكنك الدعوة الآن ومنح الأدوار لاحقًا.",
  "team.invite.rolesHint": "بدون دور، ستفتح لوحة لا يظهر فيها شيء.",
  "team.invite.sms":
    "سيُرسل رمز من 6 أرقام عبر SMS إلى هذا الرقم. صالح لمدة {hours} ساعة، ويتيح اختيار كلمة المرور في صفحة «اختيار كلمة المرور».",
  "team.invite.submit": "إرسال الدعوة",
  "team.invite.done": "تمت دعوة {name}. أُرسل الرمز عبر SMS، وهو صالح حتى {until}.",
  "team.invite.missing": "أدخل الاسم والبريد الإلكتروني والهاتف.",

  "team.deactivate.title": "تعطيل {name}",
  "team.deactivate.body":
    "لن يتمكن {name} من تسجيل الدخول مجددًا أبدًا. تنتهي جلساته المفتوحة ودعوته إن وُجدت فورًا. العضو المعطّل لا يُحذف.",
  "team.deactivate.submit": "تعطيل",
  "team.deactivate.done": "تم تعطيل {name}. الجلسات المنهاة: {count}.",
  "team.reactivate": "إعادة التفعيل",
  "team.reactivate.title": "إعادة تفعيل {name}",
  "team.reactivate.body":
    "سيتمكن {name} من تسجيل الدخول مجددًا بالأدوار التي كانت لديه. يبدأ الدخول من جديد: لا تُستعاد أي جلسة أو رمز.",
  "team.reactivate.submit": "إعادة التفعيل",
  "team.reactivate.done": "{name} نشط مجددًا.",

  "team.endSessions.title": "إنهاء جلسات {name}",
  "team.endSessions.body": "سيُسجَّل خروج {name} من كل مكان ({sessions}).",
  "team.endSessions.self": "هذه جلساتك أنت: سيُسجَّل خروجك أيضًا.",
  "team.endSessions.submit": "إنهاء",
  "team.endSessions.done": "أُنهيت جلسات {name}: {count}.",

  "team.roles.title": "أدوار {name}",
  "team.roles.held": "الأدوار الحالية",
  "team.roles.available": "أدوار أخرى",
  "team.roles.none": "لا شيء",
  "team.roles.assign": "إسناد {role}",
  "team.roles.remove": "سحب {role}",
  "team.roles.assignDone": "أُسند {role} إلى {name}.",
  "team.roles.removeDone": "سُحب {role} من {name}.",
  "team.roles.reasonFirst": "اذكر سببًا أولًا، ثم اختر الدور الذي تريد إسناده أو سحبه.",

  "team.role.createTitle": "دور جديد",
  "team.role.editTitle": "تعديل الدور {name}",
  "team.role.name": "اسم الدور",
  "team.role.description": "الوصف",
  "team.role.descriptionHint": "اختياري. ما يقوم به هذا الدور، في جملة واحدة.",
  "team.role.department": "القسم",
  "team.role.noDepartment": "لا شيء",
  "team.role.departmentHint": "المساحة التي يصل إليها حاملوه. وما يسمح به الدور تحدده الميزات.",
  "team.role.create": "إنشاء الدور",
  "team.role.save": "حفظ",
  "team.role.created": "أُنشئ الدور {name}. امنحه ميزات من الشبكة.",
  "team.role.saved": "حُفظ الدور {name}.",
  "team.role.nameTooShort": "يجب أن يتكون الاسم من حرفين على الأقل.",
  "team.role.unchanged": "عدّل الاسم أو الوصف.",
  "team.role.version": "النسخة {version}",

  // ── Permissions on a role (ADR-0019) and who can do this ──
  "team.tab.roles": "الأدوار والفريق",
  "team.tab.who": "من يمكنه فعل ذلك",
  "team.tabs.aria": "أقسام الفريق",
  "team.permission.noLimit": "بلا حد",
  "team.permission.lockFeature": "امنح {feature} للدور {role} أولاً: الإذن لا يُحتسب إلا تحت ميزته.",
  "team.cell.grantPermission": "منح {permission} للدور {role}",
  "team.cell.editPermission": "تعديل {permission} للدور {role}",
  "team.permission.grantTitle": "منح إذن",
  "team.permission.editTitle": "تعديل إذن",
  "team.permission.grantBody": "منح {permission} للدور {role} ({members}).",
  "team.permission.editBody": "الدور {role} ({members}) لديه {permission}.",
  "team.permission.under": "تحت {feature}.",
  "team.permission.approvable": "بدونه تتحول محاولتهم إلى طلب موافقة.",
  "team.permission.refusable": "بدونه يُرفض الإجراء.",
  "team.permission.limits": "الحدود",
  "team.permission.limitsHint":
    "أقصى ما يمكن لحامليه فعله بمفردهم في كل عملة. فوق ذلك، أو بعملة بلا حد، يتحول الأمر إلى طلب موافقة.",
  "team.permission.noLimitHint": "بلا حد: يتصرف حاملوه بمفردهم مهما كان المبلغ.",
  "team.permission.currency": "العملة",
  "team.permission.amount": "المبلغ",
  "team.permission.addLimit": "إضافة حد بعملة أخرى",
  "team.permission.removeLimit": "إزالة الحد بعملة {currency}",
  "team.permission.limitProblem": "أدخل عملة من ثلاثة أحرف ومبلغاً أكبر من صفر لكل حد.",
  "team.permission.duplicateCurrency": "حد واحد لكل عملة: {currency} مذكورة مرتين.",
  "team.permission.grantDone": "تم منح {permission} للدور {role}.",
  "team.permission.revokeDone": "تم سحب {permission} من الدور {role}.",
  "team.revoke.permissionsToo": "تذهب أذوناتها معها: {permissions}.",
  "team.refused.sensitivity": "وصولك لا يسمح بمنح هذا أو سحبه. اطلب ذلك من مدير العمليات أو المالك.",
  "team.refused.critical": "حرج: لا يمنحه أو يسحبه إلا مالك يحمله هو نفسه.",
  "team.refused.limitAboveOwn": "لا يمكنك منح حد أعلى من حدك. اطلب ذلك من المالك.",
  "team.refused.featureFirst": "هذا الإذن يقوم على ميزة لا يمنحها الدور. امنح الميزة أولاً.",
  "team.refused.notLimited": "هذا الإذن لا يحمل أي حد.",
  "team.refused.limitWithoutGrant": "الحد يرافق إذناً ممنوحاً.",
  "team.refused.ownRole": "أنت تحمل هذا الدور، لذا لا يمكنك تغيير ما يمنحه. اطلب ذلك من مالك آخر.",
  "team.who.action": "الإجراء",
  "team.who.feature": "الميزة",
  "team.who.permission": "الإذن",
  "team.who.noPermission": "لا يغطي أي إذن هذا الإجراء: من لديه الميزة يمكنه تنفيذه.",
  "team.who.approvable": "يمكن طلبه",
  "team.who.col.through": "عبر",
  "team.who.col.limit": "الحد",
  "team.who.personal": "مضبوط لهذا الشخص",
  "team.who.mayRequest": "يمكنه الطلب فقط: يتحول إلى طلب موافقة",
  "team.who.loading": "جارٍ تحميل من يمكنه فعل ذلك…",
  "team.who.loadFailed": "تعذّر تحميل من يمكنه فعل ذلك.",
  "team.who.empty": "لا أحد يمكنه فعل ذلك.",

  // ── Customers & pros ──
  // Trades, by WorkerCategory.
  "trade.electrician": "كهربائي",
  "trade.plumber": "سبّاك",
  "trade.mason": "بنّاء",
  "trade.carpenter": "نجّار",
  "trade.ac_technician": "فني تكييف",
  "trade.cleaner": "عاملة تنظيف",
  "trade.painter": "دهّان",
  "trade.handyman": "عامل صيانة عامة",
  "trade.laundry": "مغسلة",
  "trade.babysitter": "جليسة أطفال",
  "trade.fridge_repair": "مصلّح ثلاجات",
  "trade.moto_driver": "سائق دراجة أجرة",
  "trade.tailor": "خيّاط",
  "trade.car_mechanic": "ميكانيكي سيارات",
  "trade.welder": "لحّام",
  "trade.gardener": "بستاني",
  "trade.phone_repair": "مصلّح هواتف",
  "trade.tutor": "مدرّس خصوصي",
  "trade.hairdresser": "حلّاق",
  "trade.security_guard": "حارس",
  "trade.other": "أخرى",
  // A number with its unit (the settings' Unit).
  "unit.km": "{value} كم",
  "unit.minutes": "{value} د",
  "unit.hours": "{value} س",
  "unit.days": "{value} ي",
  "unit.seconds": "{value} ث",

  "customers.search.label": "البحث عن عميل أو محترف",
  "customers.search.placeholder": "الاسم أو الهاتف أو البريد الإلكتروني أو معرّف الحساب",
  "customers.search.hint": "مثل «621 23 45 67» أو «Sékou Touré» أو «mariama.bah@» أو معرّف الحساب.",
  "customers.search.submit": "بحث",
  "customers.search.tooShort": "أدخل حرفين على الأقل.",
  "customers.search.locked": "يتطلب البحث",
  "customers.search.idle": "أدخل اسمًا أو رقمًا أو بريدًا إلكترونيًا أو معرّفًا للعثور على حساب.",
  "customers.search.loading": "جارٍ البحث…",
  "customers.search.loadFailed": "تعذّر إتمام البحث.",
  "customers.search.empty": "لا يوجد حساب يطابق «{query}».",
  "customers.search.matchedBy.userId": "بحث بمعرّف الحساب",
  "customers.search.matchedBy.email": "بحث بالبريد الإلكتروني",
  "customers.search.matchedBy.phone": "بحث بالهاتف",
  "customers.search.matchedByPhone": "بحث بالهاتف: {phone}",
  "customers.search.matchedBy.name": "بحث بالاسم",
  "customers.search.count": "عدد الحسابات المعروضة: {count}",
  "customers.search.countOne": "حساب واحد معروض",
  "customers.search.end": "نهاية النتائج.",
  "customers.search.loadMore": "تحميل المزيد",
  "customers.search.loadingMore": "جارٍ التحميل…",
  "customers.search.moreFailed": "تعذّر تحميل الصفحة التالية. تبقى الحسابات المعروضة صالحة.",
  "customers.search.retry": "إعادة المحاولة",
  "customers.search.masked": "الأرقام والبريد الإلكتروني مخفية. «إظهار»، في صفحة الحساب ومع ذكر سبب، يُسجَّل.",
  "customers.col.name": "الاسم",
  "customers.col.contact": "التواصل",
  "customers.col.kind": "عميل أو محترف",
  "customers.col.region": "المنطقة",
  "customers.col.since": "عضو منذ",
  "customers.deleted": "حساب محذوف",
  "customers.deletedName": "اسم محذوف",
  "customers.kind.client": "عميل",
  "customers.kind.pro": "محترف",
  "customers.kind.proAndClient": "محترف وعميل",
  "customers.kind.admin": "مسؤول",
  "customers.region.gn": "غينيا",
  "customers.region.sn": "السنغال",
  "customers.region.us": "الولايات المتحدة",
  "customers.region.eu": "أوروبا",
  "customers.verification.unverified": "غير موثّقة",
  "customers.verification.pending": "قيد الانتظار",
  "customers.verification.verified": "موثّقة",
  "customers.verification.rejected": "مرفوضة",

  "customers.back": "→ البحث",
  "customers.page.loading": "جارٍ تحميل الحساب…",
  "customers.page.loadFailed": "تعذّر تحميل الحساب.",
  "customers.page.notFound": "لا يوجد حساب بهذا المعرّف. ابحث عن الشخص مجددًا.",
  "customers.page.locked": "تتطلب صفحة الحساب",
  "customers.page.sub": "{kind} · عضو منذ {since} · {region}",
  "customers.page.deletedTitle": "حساب محذوف",
  "customers.page.deletedSub": "حُذف في {date} · الاسم وبيانات التواصل ممسوحة",

  "customers.reveal.button": "إظهار",
  "customers.reveal.locked": "🔒 مخفي",
  "customers.reveal.lockedTitle": "إظهار بيانات التواصل يتطلب REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT",
  "customers.reveal.title": "إظهار بيانات التواصل الخاصة بـ {name}",
  "customers.reveal.body":
    "يظهر الرقم والبريد الإلكتروني كاملين في هذه الصفحة فقط، طوال مدة اطلاعك. يُسجَّل الإظهار في سجل الحساب مع السبب الذي ذكرته.",
  "customers.reveal.reason": "السبب",
  "customers.reveal.placeholder": "لماذا؟ مثل: معاودة الاتصال بالعميل، الملف D-0142",
  "customers.reveal.tooShort": "اذكر سببًا من 3 أحرف على الأقل.",
  "customers.reveal.submit": "إظهار",
  "customers.reveal.sending": "جارٍ الإرسال…",
  "customers.reveal.cancel": "إلغاء",
  "customers.reveal.noAnswer":
    "لا استجابة من الخادم: ربما سُجّل الإظهار دون أن تصلك بيانات التواصل. أعد المحاولة؛ وسيُسجَّل الإظهار الجديد أيضًا.",
  "customers.reveal.recorded": "أُظهرت عند {time} · الاطلاع مُسجَّل في سجل الحساب.",
  "customers.reveal.hide": "إخفاء",
  "customers.reveal.phone": "الهاتف:",
  "customers.reveal.email": "البريد الإلكتروني:",
  "customers.reveal.none": "لا يوجد",

  "customers.obo.title": "التصرف نيابةً عن {name}",
  "customers.obo.body":
    "يُرسل رمز عبر SMS إلى رقم الحساب. يقرؤه العميل بصوت عالٍ؛ تدوم الجلسة 30 دقيقة ويُسجَّل كل إجراء باسمه واسمك.",
  "customers.obo.send": "إرسال الرمز",
  "customers.obo.soon": "قريبًا",

  "customers.tabs.aria": "أقسام الحساب",
  "customers.tab.overview": "نظرة عامة",
  "customers.tab.subscription": "الاشتراك",
  "customers.tab.settings": "الميزات والإعدادات",
  "customers.tab.jobs": "الطلبات",
  "customers.tab.audit": "السجل",

  "customers.pro.title": "الملف المهني",
  "customers.pro.none": "لا يوجد ملف مهني.",
  "customers.pro.identity": "الهوية",
  "customers.pro.approval": "الاعتماد",
  "customers.pro.rating": "التقييم",
  "customers.pro.ratingValue": "{rating} ★ · عدد التقييمات: {count}",
  "customers.pro.noReviews": "لا توجد تقييمات",
  "customers.pro.rate": "السعر",
  "customers.pro.subscription": "الخطة",
  "customers.pro.noSubscription": "لا يوجد",
  "customers.pro.subscriptionLine": "{plan} · {status}",
  "customers.pro.paidUntil": "{plan} · مدفوعة حتى {date}",
  "customers.pro.endingUntil": "{plan} · نشطة حتى {date}، بلا تجديد",
  "customers.pro.approval.pending": "قيد الانتظار",
  "customers.pro.approval.approved": "معتمد",
  "customers.pro.approval.rejected": "مرفوض",
  "customers.subscription.pending": "قيد الانتظار",
  "customers.subscription.active": "نشطة",
  "customers.subscription.ending": "بلا تجديد",
  "customers.subscription.suspended": "موقوفة",
  "customers.subscription.ended": "منتهية",
  "customers.rate.hourly": "{amount} / ساعة",
  "customers.rate.daily": "{amount} / يوم",
  "customers.rate.fixed": "{amount} سعر ثابت",
  "customers.client.title": "ملف العميل",
  "customers.client.jobsPosted": "الطلبات المنشورة",
  "customers.client.lastActivity": "آخر نشاط",
  "customers.client.never": "لا يوجد",
  "customers.restrictions.title": "القيود السارية",
  "customers.restrictions.none": "لا توجد قيود.",
  "customers.restrictions.suspension": "إيقاف مؤقت",
  "customers.restrictions.line": "{feature} معطّلة لـ {scope} · السبب: {reason}",
  "customers.restrictions.until": "حتى {date}",

  "customers.settings.col.setting": "الإعداد",
  "customers.settings.col.value": "القيمة",
  "customers.settings.col.source": "المستوى",
  "customers.settings.col.reason": "السبب",
  "customers.settings.col.expires": "ينتهي",
  "customers.settings.on": "مفعّل",
  "customers.settings.off": "معطّل",
  "customers.settings.restricted": "مقيّد",
  "customers.settings.none": "لا ينطبق أي إعداد على هذا الحساب.",
  "customers.settings.edit": "تعديل إعداد",
  "customers.settings.editSoon": "قريبًا: تعديل إعدادات العميل سيتوفر في إصدار قادم.",
  "customers.settings.foot":
    "المستوى الأدق هو الذي يسري: الشخص، الملف المهني، كل المحترفين أو كل العملاء، المنطقة، النظام، ثم القيمة الافتراضية.",
  "customers.source.user": "الشخص",
  "customers.source.proProfile": "الملف المهني",
  "customers.source.allPros": "كل المحترفين",
  "customers.source.allClients": "كل العملاء",
  "customers.source.region": "المنطقة",
  "customers.source.regionOf": "منطقة {region}",
  "customers.source.appVersion": "إصدار التطبيق",
  "customers.source.system": "النظام",
  "customers.source.default": "افتراضي",
  "customers.scope.user": "الشخص",
  "customers.scope.proProfile": "الملف المهني",

  "customers.jobs.col.trade": "المهنة",
  "customers.jobs.col.type": "النوع",
  "customers.jobs.col.side": "الدور",
  "customers.jobs.col.other": "مع",
  "customers.jobs.col.status": "الحالة",
  "customers.jobs.col.date": "التاريخ",
  "customers.jobs.type.direct": "مباشر",
  "customers.jobs.type.open": "مفتوح",
  "customers.jobs.side.client": "عميل",
  "customers.jobs.side.pro": "محترف",
  "customers.jobs.status.requested": "مطلوب",
  "customers.jobs.status.quoted": "أُرسل عرض السعر",
  "customers.jobs.status.accepted": "تم التعارف",
  "customers.jobs.status.cancelled": "ملغى",
  "customers.jobs.noPro": "لم يُختر محترف",
  "customers.jobs.deletedParty": "حساب محذوف",
  "customers.jobs.none": "لا توجد طلبات لهذا الحساب.",
  "customers.jobs.foot": "آخر الطلبات بحد أقصى {count}، كعميل أو كمحترف.",

  "customers.journal.recorded": "اطلاعك على هذا السجل مُسجَّل هو أيضًا.",
  "customers.journal.locked": "يتطلب سجل التدقيق",
  "customers.lockedRoles": "أدوارك ({roles}) لا تشمله.",
  "customers.journal.onBehalf": "نيابةً عن {id}",
  "customers.journal.actorWithRoles": "{name} ({roles})",
  "customers.journal.reason": "السبب: {reason}",
  "customers.journal.empty": "لم يُسجَّل شيء لهذا الحساب بعد.",
  "customers.journal.all": "فتح في سجل التدقيق ←",
  "customers.journal.denied": "مرفوض",
  "customers.journal.succeeded": "نجح",

  // ── Choose my password (public) ──
  "setPassword.title": "اختيار كلمة المرور",
  "setPassword.subtitle": "استخدم الرمز المكوّن من 6 أرقام الذي وصلك عبر SMS مع دعوتك.",
  "setPassword.email": "البريد الإلكتروني المهني",
  "setPassword.code": "الرمز المستلم عبر SMS",
  "setPassword.password": "كلمة المرور الجديدة",
  "setPassword.confirm": "تأكيد كلمة المرور",
  "setPassword.rules": "يجب أن تكون كلمة المرور:",
  "setPassword.rule.length": "مكوّنة من {min} أحرف على الأقل",
  "setPassword.rule.tooLong": "مكوّنة من {max} حرفًا على الأكثر",
  "setPassword.rule.mix": "محتوية على حرف ورمز ليس حرفًا",
  "setPassword.rule.email": "خالية من بريدك الإلكتروني ({name})",
  "setPassword.rule.emailGeneric": "خالية من بريدك الإلكتروني",
  "setPassword.mismatch": "كلمتا المرور غير متطابقتين.",
  "setPassword.codeFormat": "يتكون الرمز من 6 أرقام.",
  "setPassword.emailFormat": "أدخل بريدًا إلكترونيًا صالحًا.",
  "setPassword.submit": "حفظ كلمة المرور",
  "setPassword.submitting": "جارٍ الحفظ…",
  "setPassword.back": "العودة إلى تسجيل الدخول",
  "setPassword.done": "حُفظت كلمة المرور. سجّل الدخول ببريدك الإلكتروني وكلمة المرور هذه.",
  "signIn.setPassword": "مدعو؟ اختر كلمة المرور",
  "signIn.or": "أو",
  "signIn.heading": "وحدة تحكم واليو",
  "signIn.forgot": "هل نسيت كلمة المرور؟",
  "signIn.environment": "البيئة",
  "signIn.build": "الإصدار",
  "signIn.googleUnavailable": "تسجيل الدخول عبر Google غير متاح. استخدم بريدك وكلمة المرور، أو أبلغ المالك.",
  "error.setPassword.invalid_code":
    "هذا البريد الإلكتروني وهذا الرمز لا يطابقان أي دعوة مفتوحة. تحقق منهما؛ وإن فُقد الرمز أو انتهت صلاحيته، اطلب دعوة جديدة.",
  "error.setPassword.too_many_attempts": "رموز خاطئة كثيرة جدًا: لم يعد هذا الرمز صالحًا. اطلب دعوة جديدة.",
  "error.setPassword.validation_error": "كلمة المرور لا تستوفي القواعد، أو صيغة الرمز غير صحيحة. صحّح وأعد المحاولة.",

  // ── Dossiers (the support case queue) ──
  "cases.newCall": "+ تسجيل مكالمة",
  "cases.queue.aria": "قائمة انتظار الملفات",
  "cases.queue.views": "عروض قائمة الانتظار",
  "cases.view.all": "الكل",
  "cases.view.unassigned": "غير مُسندة",
  "cases.view.mine": "ملفاتي",
  "cases.view.late": "متأخرة",
  "cases.filter.status": "الحالة",
  "cases.filter.notClosed": "الكل ما عدا المغلقة",
  "cases.filter.channel": "القناة",
  "cases.filter.anyChannel": "كل القنوات",
  "cases.filter.customer": "العميل {id}",
  "cases.filter.clear": "إزالة عامل تصفية العميل",
  "cases.col.case": "الملف",
  "cases.col.deadline": "المهلة",
  "cases.queue.loading": "جارٍ تحميل قائمة الانتظار…",
  "cases.queue.loadFailed": "تعذّر تحميل قائمة الانتظار.",
  "cases.queue.empty": "لا يطابق أي ملف عوامل التصفية هذه.",
  "cases.loadMore": "تحميل المزيد",
  "cases.loadingMore": "جارٍ التحميل…",
  "cases.retry": "أعد المحاولة",
  "cases.pick": "اختر ملفًا من قائمة الانتظار لعرض تسلسله الزمني.",
  "cases.loading": "جارٍ تحميل الملف…",
  "cases.loadFailed": "تعذّر تحميل هذا الملف.",
  "cases.notFound": "لا يوجد ملف بهذا المعرّف. ربما نُسخ بشكل خاطئ.",
  "cases.refreshFailed": "تعذّر تحديث الملف: قد يكون ما تراه قديمًا.",
  "cases.deadline.late": "متأخر · {time}",
  "cases.deadline.left": "متبقٍّ {time}",
  "cases.deadline.replied": "تم الرد",
  "cases.deadline.closed": "مغلق",
  "cases.channel.phone": "مكالمة",
  "cases.channel.email": "بريد إلكتروني",
  "cases.channel.chat": "دردشة داخل التطبيق",
  "cases.status.open": "مفتوح",
  "cases.status.waiting_on_customer": "بانتظار العميل",
  "cases.status.closed": "مغلق",
  "access.mine.title": "ما طلبته",
  "access.mine.none": "لم تطلب شيئًا.",
  "access.mine.what": "ماذا",
  "access.mine.state": "إلى أين وصل",
  "access.mine.asked": "طُلِب",
  "access.mine.withWhom": "لدى",
  "access.mine.waiting": "قيد الانتظار",
  "access.mine.granted": "مُنِح",
  "access.mine.refused": "مرفوض",
  "access.mine.overdue": "متأخر",
  "access.mine.nobody": "لا أحد بعد",
  "access.mine.answer": "الرد",
  "access.mine.loading": "جارٍ تحميل طلباتك…",
  "access.mine.loadFailed": "تعذّرت قراءة طلباتك.",
  "access.ask.title": "طلب المزيد",
  "access.ask.explain":
    "بناء الشيء ليس سببًا لحيازة بياناته. اطلب أقل ما يُمكّنك من الإنهاء، للمدة التي تحتاجها. يذهب إلى من يمكنه منحه، ويُمنح لك وحدك، وينتهي من تلقاء نفسه.",
  "access.ask.what": "ما تحتاجه",
  "access.ask.until": "حتى",
  "access.ask.why": "لماذا تحتاجه",
  "access.ask.whyHint": "ما الذي تفعله، ولماذا هذا أقل ما يُمكّنك منه",
  "access.ask.send": "إرسال الطلب",
  "access.ask.pickOne": "اختر ما تحتاجه",
  "access.ask.pastDate": "اذكر تاريخًا في المستقبل، أو اتركه مفتوحًا.",
  "access.ask.sent": "تم الإرسال. إنه الملف {reference}.",
  "cases.kind.access": "طلب وصول",
  "cases.kind.customer": "عميل",
  "cases.kind": "النوع",
  "cases.access.wants": "يطلب",
  "cases.access.until": "حتى",
  "cases.access.grant": "منح",
  "cases.access.refuse": "رفض",
  "cases.access.own": "لا يمكنك الرد على طلبك الخاص.",
  "cases.access.explain":
    "يُمنح لهذا الشخص وحده، لا لفريقه. ينتهي في التاريخ المطلوب، ويمكن لمن يملك الصلاحية إنهاؤه قبل ذلك.",
  "cases.priority": "الأولوية: {priority}",
  "cases.priority.low": "منخفضة",
  "cases.priority.normal": "عادية",
  "cases.priority.high": "مرتفعة",
  "cases.priority.urgent": "عاجلة",
  "cases.unknownCaller": "متصل مجهول",
  "cases.unknownCallerPhone": "متصل مجهول · {phone}",
  "cases.customerWithPhone": "{name} · {phone}",
  "cases.ownedBy": "مُسند إلى {name}",
  "cases.unassigned": "غير مُسند",
  "cases.closedBecause": "مغلق · السبب: {reason}",
  "cases.timeline.aria": "التسلسل الزمني للملف",
  "cases.timeline.empty": "لم يُسجَّل شيء في هذا الملف بعد.",
  "cases.internal": "داخلي",
  "cases.entry.call": "مكالمة",
  "cases.entry.callWithDuration": "مكالمة ({duration})",
  "cases.entry.note": "ملاحظة داخلية",
  "cases.entry.chatIn": "رسالة العميل في التطبيق",
  "cases.entry.chatOut": "رد في التطبيق",
  "cases.entry.smsIn": "رسالة SMS من العميل",
  "cases.entry.smsOut": "رد عبر SMS",
  "cases.entry.smsOutTo": "رسالة SMS إلى {phone}",
  "cases.entry.emailIn": "بريد إلكتروني من العميل",
  "cases.entry.emailOut": "رد عبر البريد الإلكتروني",
  "cases.sms.pending": "جارٍ الإرسال",
  "cases.sms.sent": "أُرسلت",
  "cases.sms.failed": "لم تُرسل",
  "cases.action.claim": "تولَّ الملف",
  "cases.action.reassign": "إعادة الإسناد",
  "cases.action.link": "ربط بعميل",
  "cases.action.relink": "تغيير العميل",
  "cases.action.close": "إغلاق",
  "cases.needs": "يتطلب {feature}",
  "cases.sending": "جارٍ الإرسال…",
  "cases.cancel": "إلغاء",
  "cases.reload": "أعد تحميل الملف",
  "cases.reason": "السبب",
  "cases.reasonHint": "يُسجَّل في سجل التدقيق مع اسمك.",
  "cases.stale": "تغيّر هذا الملف أثناء اطلاعك عليه. أعد تحميله وتحقق مما تغيّر ثم حاول مجددًا: نصّك محفوظ.",
  "cases.claim.done": "أصبح {reference} لك.",
  "cases.claim.taken": "فات الأوان: تولّى {name} هذا الملف للتو. اختر ملفًا آخر.",
  "cases.composer.aria": "الكتابة في الملف",
  "cases.composer.reply": "الرد",
  "cases.composer.note": "ملاحظة داخلية",
  "cases.composer.call": "تسجيل مكالمة",
  "cases.reply.noChannel": "لا يوجد حساب عميل مرتبط: اربط العميل للرد داخل التطبيق، أو عاود الاتصال به.",
  "cases.reply.notified": "يتلقى العميل إشعارًا داخل التطبيق. لا رسائل SMS أبدًا.",
  "cases.reply.label": "الرد على {name}",
  "cases.reply.sendChat": "إرسال في التطبيق",
  "cases.reply.doneChat": "أُرسل الرد في التطبيق.",
  "cases.reply.closed": "هذا الملف مغلق: لم يعد يقبل ردودًا.",
  "cases.reply.unassigned": "تولَّ هذا الملف لتردّ على العميل.",
  "cases.reply.notOwner": "المسؤول عن الملف وحده يردّ على العميل. اطلب إعادة الإسناد إن لزم.",
  "cases.refused.claimed": "فات الأوان: تولّى شخص آخر هذا الملف للتو. اختر ملفًا آخر.",
  "cases.refused.closed": "أُغلق هذا الملف في الأثناء. أعد تحميله.",
  "cases.refused.notOwner": "أصبح هذا الملف مسندًا إلى شخص آخر. أعد تحميله، أو اطلب إعادة إسناده.",
  "cases.refused.noCustomer": "لا يوجد حساب عميل مرتبط: اربط العميل للرد داخل التطبيق، أو عاود الاتصال به.",
  "cases.note.hint": "يراها الفريق فقط، ولا يراها العميل أبدًا.",
  "cases.note.label": "ملاحظة داخلية",
  "cases.note.submit": "إضافة الملاحظة",
  "cases.note.done": "أُضيفت الملاحظة الداخلية.",
  "cases.call.label": "ما قيل (ملخص داخلي)",
  "cases.call.minutes": "المدة (بالدقائق)",
  "cases.call.submit": "تسجيل المكالمة",
  "cases.call.done": "سُجّلت المكالمة.",
  "cases.reassign.title": "إعادة إسناد {reference}",
  "cases.reassign.from": "مُسند حاليًا إلى {name}.",
  "cases.reassign.unassigned": "هذا الملف غير مُسند إلى أحد بعد.",
  "cases.reassign.to": "المسؤول الجديد",
  "cases.reassign.choose": "اختر عضوًا من الفريق",
  "cases.reassign.loading": "جارٍ تحميل الفريق…",
  "cases.reassign.toId": "معرّف عضو الفريق",
  "cases.reassign.idHint": "إن لم تكن لديك صلاحية على قائمة الفريق، الصق معرّف العضو.",
  "cases.reassign.submit": "إعادة الإسناد",
  "cases.reassign.done": "أُعيد إسناد الملف إلى {name}.",
  "cases.close.title": "إغلاق {reference}",
  "cases.close.body": "لن يتمكن العميل من الرد عليه بعد الآن؛ وإن عاد، يُفتح ملف جديد.",
  "cases.close.submit": "إغلاق الملف",
  "cases.close.done": "أُغلق {reference}.",
  "cases.link.title": "ربط {reference} بعميل",
  "cases.link.body": "ابحث عن حساب العميل الذي تواصل مع الدعم.",
  "cases.link.caller": "أعطى المتصل الرقم {phone}. ابحث عن حسابه.",
  "cases.link.current": "مرتبط حاليًا بـ {name}.",
  "cases.link.submit": "ربط",
  "cases.link.done": "رُبط الملف بـ {name}.",
  "cases.customer.search": "البحث عن العميل",
  "cases.customer.placeholder": "الاسم أو الهاتف أو البريد الإلكتروني أو المعرّف",
  "cases.customer.searchButton": "بحث",
  "cases.customer.searching": "جارٍ البحث…",
  "cases.customer.none": "لم يُعثر على أي حساب.",
  "cases.customer.results": "الحسابات التي عُثر عليها",
  "cases.customer.id": "معرّف حساب العميل",
  "cases.customer.idHint": "يتطلب البحث {feature}: الصق معرّف الحساب.",
  "cases.newCall.title": "تسجيل مكالمة",
  "cases.newCall.who": "من اتصل؟",
  "cases.newCall.known": "عميل",
  "cases.newCall.unknown": "متصل مجهول",
  "cases.newCall.phone": "رقم المتصل",
  "cases.newCall.phoneHint": "بالصيغة الدولية، مثلًا ‎+224 621 23 45 67‎.",
  "cases.newCall.subject": "الموضوع",
  "cases.newCall.internal": "داخلي: لا يرى العميل هذا الملخص أبدًا.",
  "cases.newCall.priority": "الأولوية",
  "cases.newCall.submit": "فتح الملف",
  "cases.problem.reason": "اذكر السبب في كلمات قليلة.",
  "cases.problem.body": "اكتب شيئًا.",
  "cases.problem.tooLong": "طويل جدًا: {max} حرفًا على الأكثر.",
  "cases.problem.minutes": "المدة عدد صحيح من الدقائق، من 0 إلى {max}.",
  "cases.problem.phone": "يجب أن يكون الرقم بالصيغة الدولية، مثلًا ‎+224621234567‎.",
  "cases.problem.pickCustomer": "اختر العميل.",
  "cases.problem.customerId": "صيغة معرّف الحساب هذا غير صحيحة.",
  "cases.problem.pickStaff": "اختر من يتولى الملف.",
  "cases.problem.staffId": "صيغة معرّف العضو هذا غير صحيحة.",
  "cases.problem.subject": "أعطِ الملف موضوعًا قصيرًا.",
  // ── التحقق من الهوية ──
  "verifications.summary.open": "{count} في الانتظار · أقدمها منذ {age}",
  "verifications.summary.none": "لا يوجد طلب تحقق في الانتظار",
  "verifications.summary.shown": "طلبات التحقق المعروضة: {count}",
  "verifications.filter.status": "الحالة",
  "verifications.filter.status.open": "كل المنتظرة",
  "verifications.filter.status.submitted": "للمراجعة",
  "verifications.filter.status.flagged": "وثيقة محظورة",
  "verifications.filter.status.approved": "مقبولة",
  "verifications.filter.status.rejected": "مرفوضة",
  "verifications.filter.document": "نوع الوثيقة",
  "verifications.filter.document.all": "الكل",
  "verifications.filter.document.national_id": "بطاقة الهوية",
  "verifications.filter.document.passport": "جواز السفر",
  "verifications.queue.aria": "قائمة طلبات التحقق، الأقدم أولًا",
  "verifications.queue.loading": "جارٍ تحميل القائمة…",
  "verifications.queue.loadFailed": "تعذّر تحميل القائمة.",
  "verifications.queue.emptyOpen": "لا يوجد طلب تحقق في الانتظار: القائمة فارغة.",
  "verifications.queue.empty": "لا يوجد طلب تحقق يطابق هذه المرشحات.",
  "verifications.queue.waited": "مدة الانتظار منذ الإرسال",
  "verifications.queue.end": "نهاية القائمة.",
  "verifications.flag.banned": "وثيقة محظورة",
  "verifications.status.submitted": "للمراجعة",
  "verifications.status.flagged": "وثيقة محظورة",
  "verifications.status.approved": "مقبول",
  "verifications.status.rejected": "مرفوض",
  "verifications.document.national_id": "بطاقة الهوية",
  "verifications.document.passport": "جواز السفر",
  "verifications.side.front": "الوجه الأمامي",
  "verifications.side.back": "الوجه الخلفي",
  "verifications.side.selfie": "صورة سيلفي",
  "verifications.detail.pick": "اختر طلب تحقق من القائمة لمراجعته.",
  "verifications.detail.loading": "جارٍ تحميل طلب التحقق…",
  "verifications.detail.loadFailed": "تعذّر تحميل طلب التحقق هذا.",
  "verifications.detail.notFound": "لا يوجد طلب تحقق بهذا المعرّف. أعد تحميل القائمة.",
  "verifications.detail.noPhone": "بلا هاتف",
  "verifications.detail.submitted": "أُرسل في {date}",
  "verifications.detail.versionTitle": "النسخة التي تمت مراجعتها: القرار ينطبق على هذه النسخة فقط",
  "verifications.banned.title": "وثيقة محظورة",
  "verifications.banned.body":
    "هذا الرقم يطابق وثيقة حُظرت في {date} · السبب: {reason}. لا يمكن قبولها أبدًا: ارفض طلب التحقق.",
  "verifications.banned.bodyNoReason": "هذا الرقم يطابق وثيقة محظورة. لا يمكن قبولها أبدًا: ارفض طلب التحقق.",
  "verifications.banned.notTold": "لا يُبلَّغ المحترف بأن وثيقته محظورة.",
  "verifications.images.aria": "وثائق الهوية",
  "verifications.images.show": "عرض الوثائق",
  "verifications.images.showAgain": "العرض مرة أخرى",
  "verifications.images.loading": "جارٍ التحميل…",
  "verifications.images.notice":
    "كل عرض يُسجَّل في سجل التدقيق باسمك، ويظهر في سجل المحترف. تنتهي صلاحية الروابط بعد دقيقتين.",
  "verifications.images.recorded": "سُجّل العرض في سجل التدقيق · الروابط صالحة حتى {time}",
  "verifications.images.hide": "إخفاء",
  "verifications.images.expired": "انتهت صلاحية الروابط وأُزيلت الصور من الشاشة. العرض من جديد يُسجَّل أيضًا.",
  "verifications.images.locked": "صور الهوية تتطلب",
  "verifications.images.deleted": "حُذفت الصور في {date}، كما تقتضي قاعدة الاحتفاظ.",
  "verifications.col.field": "الحقل",
  "verifications.col.read": "المقروء على الوثيقة",
  "verifications.col.typed": "ما أدخله المحترف",
  "verifications.col.match": "التطابق",
  "verifications.field.name": "الاسم",
  "verifications.field.dateOfBirth": "تاريخ الميلاد",
  "verifications.field.expiresOn": "تاريخ الانتهاء",
  "verifications.field.documentNumber": "رقم الوثيقة",
  "verifications.notAsked": "غير مطلوب",
  "verifications.match.check": "يُتحقق منه على الصورة",
  "verifications.match.same": "متطابق",
  "verifications.match.different": "غير متطابق",
  "verifications.match.readOnly": "مقروء فقط",
  "verifications.match.expired": "منتهية الصلاحية",
  "verifications.match.valid": "سارية",
  "verifications.match.banned": "محظورة",
  "verifications.match.notBanned": "غير محظورة",
  "verifications.last4Hint": "لا يُحتفظ إلا بآخر 4 أحرف من الرقم ({last4}): قارنها بالصورة.",
  "verifications.standing.title": "حساب المحترف اليوم",
  "verifications.standing.verificationStatus": "حالة التحقق",
  "verifications.standing.approvalStatus": "اعتماد الملف الشخصي",
  "verifications.standing.isVerified": "شارة «موثَّق»",
  "verifications.standing.status.unverified": "غير موثَّق",
  "verifications.standing.status.pending": "قيد المراجعة",
  "verifications.standing.status.verified": "موثَّق",
  "verifications.standing.status.rejected": "مرفوض",
  "verifications.standing.approval.pending": "بانتظار الاعتماد",
  "verifications.standing.approval.approved": "معتمد",
  "verifications.standing.approval.rejected": "غير معتمد",
  "verifications.yes": "نعم",
  "verifications.no": "لا",
  "verifications.previous.title": "طلبات سابقة",
  "verifications.previous.none": "أول طلب لهذا المحترف.",
  "verifications.approve.button": "اعتماد المحترف",
  "verifications.reject.button": "رفض",
  "verifications.decided": "تم البت في طلب التحقق هذا بالفعل.",
  "verifications.approve.banned": "لا يمكن الاعتماد: الرقم يطابق وثيقة محظورة. ارفض طلب التحقق.",
  "verifications.approve.locked": "الاعتماد يتطلب أيضًا APPROVE_PROS_STAFF_FEATURE_ENABLEMENT، وأدوارك لا تتضمنها.",
  "verifications.decided.approved": "اعتمده {name} في {date}.",
  "verifications.decided.rejected": "رفضه {name} في {date}.",
  "verifications.decided.reasonCode": "السبب: {reason}",
  "verifications.decided.reason": "ملاحظة الفريق: «{reason}»",
  "verifications.outcome.approved": "تم اعتماد {name}: ملفه موثَّق، ويمكن العثور عليه والتعاقد معه.",
  "verifications.outcome.rejected": "رُفض التحقق. أُبلغ المهني داخل التطبيق، بلغته.",
  "verifications.approve.title": "اعتماد {name}",
  "verifications.approve.body":
    "تُقبل الوثيقة ويصبح المحترف موثَّقًا: يمكن العثور عليه والتعاقد معه. يُسجَّل القرار في سجل التدقيق مع السبب الذي تكتبه.",
  "verifications.approve.reason": "السبب (يُسجَّل في سجل التدقيق)",
  "verifications.approve.hint": "مثال: «البطاقة مقروءة، والسيلفي مطابق».",
  "verifications.approve.submit": "اعتماد المحترف",
  "verifications.approve.tooShort": "اكتب سببًا من {min} أحرف على الأقل.",
  "verifications.reject.title": "رفض طلب تحقق {name}",
  "verifications.reject.body": "يمكن للمحترف إرسال وثيقة جديدة من التطبيق.",
  "verifications.reject.preset": "سبب الرفض",
  "verifications.reject.presetNone": "اختر سببًا…",
  "verifications.reject.code.photo_unreadable": "صورة غير واضحة",
  "verifications.reject.code.selfie_mismatch": "الصورة الشخصية لا تطابق",
  "verifications.reject.code.document_expired": "وثيقة منتهية الصلاحية",
  "verifications.reject.code.document_not_accepted": "وثيقة غير مقبولة",
  "verifications.reject.code.other": "سبب آخر",
  "verifications.reject.reason": "ملاحظة للفريق (اختيارية)",
  "verifications.reject.noteHint": "لا تُعرض على المهني أبدًا: يتلقى داخل التطبيق رسالة السبب الذي اخترته، بلغته.",
  "verifications.reject.submit": "رفض التحقق",
  "verifications.reject.pickCode": "اختر سبب الرفض.",
  "verifications.reason.tooLong": "يجب ألا يتجاوز السبب {max} حرفًا.",
  "verifications.reason.count": "{count} من {max} حرفًا",
  "verifications.dialog.version": "قرار بشأن النسخة {version}",
  "verifications.dialog.cancel": "إلغاء",
  "verifications.dialog.sending": "جارٍ الإرسال…",
  "verifications.error.stale":
    "تغيّر طلب التحقق هذا أثناء اطلاعك عليه (ربما بتّ فيه شخص آخر). أعد التحميل لرؤية النسخة الحالية، ثم قرّر من جديد.",
  "verifications.error.approveRefused":
    "رُفض الاعتماد: أدوارك لا تتضمن REVIEW_VERIFICATIONS وAPPROVE_PROS، أو حُظرت الوثيقة للتو. أعد التحميل.",
  "verifications.error.rejectRefused":
    "لا يمكن الرفض: لم تعد أدوارك تتضمن REVIEW_VERIFICATIONS. اطلب الصلاحية من مسؤول.",
  "verifications.error.imagesRefused":
    "رُفض عرض الصور: لم تعد أدوارك تتضمن VIEW_ID_IMAGES. سُجّلت هذه المحاولة في سجل التدقيق.",
  "verifications.error.approveInvalid":
    "رُفض الاعتماد: تم البت في طلب التحقق، أو الوثيقة محظورة، أو السبب غير صالح. أعد التحميل وتحقق.",
  "verifications.error.rejectInvalid": "رُفض الرفض: تم البتّ في التحقق مسبقًا، أو تتجاوز الملاحظة {max} حرفًا.",
  "verifications.error.imagesDeleted": "الصور لم تعد متاحة: حُذفت وفق قاعدة الاحتفاظ، أو لم يُعثر على طلب التحقق.",
  "verifications.error.outcomeUnknown":
    "لا رد من الخادم: ربما حُفظ القرار. أعد المحاولة: النقرة نفسها لا يمكن تطبيقها مرتين.",
};
